var items = {
  "block.minecraft.acacia_button": "Акацієва кнопка",
  "block.minecraft.acacia_door": "Акацієві двері",
  "block.minecraft.acacia_fence": "Акацієвий паркан",
  "block.minecraft.acacia_fence_gate": "Акацієва хвіртка",
  "block.minecraft.acacia_hanging_sign": "Акацієва вивіска",
  "block.minecraft.acacia_leaves": "Акацієве листя",
  "block.minecraft.acacia_log": "Акацієва колода",
  "block.minecraft.acacia_planks": "Акацієві дошки",
  "block.minecraft.acacia_pressure_plate": "Акацієва натискна плита",
  "block.minecraft.acacia_sapling": "Паросток акації",
  "block.minecraft.acacia_shelf": "Акацієва полиця",
  "block.minecraft.acacia_sign": "Акацієва табличка",
  "block.minecraft.acacia_slab": "Акацієва плита",
  "block.minecraft.acacia_stairs": "Акацієві сходи",
  "block.minecraft.acacia_trapdoor": "Акацієвий люк",
  "block.minecraft.acacia_wall_hanging_sign": "Акацієва настінна вивіска",
  "block.minecraft.acacia_wall_sign": "Акацієва настінна табличка",
  "block.minecraft.acacia_wood": "Акацієва деревина",
  "block.minecraft.activator_rail": "Активаторні рейки",
  "block.minecraft.air": "Повітря",
  "block.minecraft.allium": "Різанець",
  "block.minecraft.amethyst_block": "Блок аметиста",
  "block.minecraft.amethyst_cluster": "Аметистова друза",
  "block.minecraft.ancient_debris": "Стародавні залишки",
  "block.minecraft.andesite": "Андезит",
  "block.minecraft.andesite_slab": "Андезитова плита",
  "block.minecraft.andesite_stairs": "Андезитові сходи",
  "block.minecraft.andesite_wall": "Андезитова стіна",
  "block.minecraft.anvil": "Ковадло",
  "block.minecraft.attached_melon_stem": "Приєднане стебло кавуна",
  "block.minecraft.attached_pumpkin_stem": "Приєднане стебло гарбуза",
  "block.minecraft.azalea": "Азалія",
  "block.minecraft.azalea_leaves": "Азалієве листя",
  "block.minecraft.azure_bluet": "Черемша",
  "block.minecraft.bamboo": "Бамбук",
  "block.minecraft.bamboo_block": "Блок бамбука",
  "block.minecraft.bamboo_button": "Бамбукова кнопка",
  "block.minecraft.bamboo_door": "Бамбукові двері",
  "block.minecraft.bamboo_fence": "Бамбуковий паркан",
  "block.minecraft.bamboo_fence_gate": "Бамбукова хвіртка",
  "block.minecraft.bamboo_hanging_sign": "Бамбукова вивіска",
  "block.minecraft.bamboo_mosaic": "Бамбукова мозаїка",
  "block.minecraft.bamboo_mosaic_slab": "Плита з бамбукової мозаїки",
  "block.minecraft.bamboo_mosaic_stairs": "Сходи з бамбукової мозаїки",
  "block.minecraft.bamboo_planks": "Бамбукові дошки",
  "block.minecraft.bamboo_pressure_plate": "Бамбукова натискна плита",
  "block.minecraft.bamboo_sapling": "Саджанець бамбука",
  "block.minecraft.bamboo_shelf": "Бамбукова полиця",
  "block.minecraft.bamboo_sign": "Бамбукова табличка",
  "block.minecraft.bamboo_slab": "Бамбукова плита",
  "block.minecraft.bamboo_stairs": "Бамбукові сходи",
  "block.minecraft.bamboo_trapdoor": "Бамбуковий люк",
  "block.minecraft.bamboo_wall_hanging_sign": "Бамбукова настінна вивіска",
  "block.minecraft.bamboo_wall_sign": "Бамбукова настінна табличка",
  "block.minecraft.banner.base.black": "Цілком чорне поле",
  "block.minecraft.banner.base.blue": "Цілком синє поле",
  "block.minecraft.banner.base.brown": "Цілком коричневе поле",
  "block.minecraft.banner.base.cyan": "Цілком бірюзове поле",
  "block.minecraft.banner.base.gray": "Цілком сіре поле",
  "block.minecraft.banner.base.green": "Цілком зелене поле",
  "block.minecraft.banner.base.light_blue": "Цілком блакитне поле",
  "block.minecraft.banner.base.light_gray": "Цілком світло-сіре поле",
  "block.minecraft.banner.base.lime": "Цілком лаймове поле",
  "block.minecraft.banner.base.magenta": "Цілком пурпурове поле",
  "block.minecraft.banner.base.orange": "Цілком помаранчеве поле",
  "block.minecraft.banner.base.pink": "Цілком рожеве поле",
  "block.minecraft.banner.base.purple": "Цілком фіолетове поле",
  "block.minecraft.banner.base.red": "Цілком червоне поле",
  "block.minecraft.banner.base.white": "Цілком біле поле",
  "block.minecraft.banner.base.yellow": "Цілком жовте поле",
  "block.minecraft.banner.border.black": "Чорна рамка",
  "block.minecraft.banner.border.blue": "Синя рамка",
  "block.minecraft.banner.border.brown": "Коричнева рамка",
  "block.minecraft.banner.border.cyan": "Бірюзова рамка",
  "block.minecraft.banner.border.gray": "Сіра рамка",
  "block.minecraft.banner.border.green": "Зелена рамка",
  "block.minecraft.banner.border.light_blue": "Блакитна рамка",
  "block.minecraft.banner.border.light_gray": "Світло-сіра рамка",
  "block.minecraft.banner.border.lime": "Лаймова рамка",
  "block.minecraft.banner.border.magenta": "Пурпурова рамка",
  "block.minecraft.banner.border.orange": "Помаранчева рамка",
  "block.minecraft.banner.border.pink": "Рожева рамка",
  "block.minecraft.banner.border.purple": "Фіолетова рамка",
  "block.minecraft.banner.border.red": "Червона рамка",
  "block.minecraft.banner.border.white": "Біла рамка",
  "block.minecraft.banner.border.yellow": "Жовта рамка",
  "block.minecraft.banner.bricks.black": "Чорне цегляне тло",
  "block.minecraft.banner.bricks.blue": "Синє цегляне тло",
  "block.minecraft.banner.bricks.brown": "Коричневе цегляне тло",
  "block.minecraft.banner.bricks.cyan": "Бірюзове цегляне тло",
  "block.minecraft.banner.bricks.gray": "Сіре цегляне тло",
  "block.minecraft.banner.bricks.green": "Зелене цегляне тло",
  "block.minecraft.banner.bricks.light_blue": "Блакитне цегляне тло",
  "block.minecraft.banner.bricks.light_gray": "Світло-сіре цегляне тло",
  "block.minecraft.banner.bricks.lime": "Лаймове цегляне тло",
  "block.minecraft.banner.bricks.magenta": "Пурпурове цегляне тло",
  "block.minecraft.banner.bricks.orange": "Помаранчеве цегляне тло",
  "block.minecraft.banner.bricks.pink": "Рожеве цегляне тло",
  "block.minecraft.banner.bricks.purple": "Фіолетове цегляне тло",
  "block.minecraft.banner.bricks.red": "Червоне цегляне тло",
  "block.minecraft.banner.bricks.white": "Біле цегляне тло",
  "block.minecraft.banner.bricks.yellow": "Жовте цегляне тло",
  "block.minecraft.banner.circle.black": "Чорний круг",
  "block.minecraft.banner.circle.blue": "Синій круг",
  "block.minecraft.banner.circle.brown": "Коричневий круг",
  "block.minecraft.banner.circle.cyan": "Бірюзовий круг",
  "block.minecraft.banner.circle.gray": "Сірий круг",
  "block.minecraft.banner.circle.green": "Зелений круг",
  "block.minecraft.banner.circle.light_blue": "Блакитний круг",
  "block.minecraft.banner.circle.light_gray": "Світло-сірий круг",
  "block.minecraft.banner.circle.lime": "Лаймовий круг",
  "block.minecraft.banner.circle.magenta": "Пурпуровий круг",
  "block.minecraft.banner.circle.orange": "Помаранчевий круг",
  "block.minecraft.banner.circle.pink": "Рожевий круг",
  "block.minecraft.banner.circle.purple": "Фіолетовий круг",
  "block.minecraft.banner.circle.red": "Червоний круг",
  "block.minecraft.banner.circle.white": "Білий круг",
  "block.minecraft.banner.circle.yellow": "Жовтий круг",
  "block.minecraft.banner.creeper.black": "Чорна емблема кріпера",
  "block.minecraft.banner.creeper.blue": "Синя емблема кріпера",
  "block.minecraft.banner.creeper.brown": "Коричнева емблема кріпера",
  "block.minecraft.banner.creeper.cyan": "Бірюзова емблема кріпера",
  "block.minecraft.banner.creeper.gray": "Сіра емблема кріпера",
  "block.minecraft.banner.creeper.green": "Зелена емблема кріпера",
  "block.minecraft.banner.creeper.light_blue": "Блакитна емблема кріпера",
  "block.minecraft.banner.creeper.light_gray": "Світло-сіра емблема кріпера",
  "block.minecraft.banner.creeper.lime": "Лаймова емблема кріпера",
  "block.minecraft.banner.creeper.magenta": "Пурпурова емблема кріпера",
  "block.minecraft.banner.creeper.orange": "Помаранчева емблема кріпера",
  "block.minecraft.banner.creeper.pink": "Рожева емблема кріпера",
  "block.minecraft.banner.creeper.purple": "Фіолетова емблема кріпера",
  "block.minecraft.banner.creeper.red": "Червона емблема кріпера",
  "block.minecraft.banner.creeper.white": "Біла емблема кріпера",
  "block.minecraft.banner.creeper.yellow": "Жовта емблема кріпера",
  "block.minecraft.banner.cross.black": "Чорний косий хрест",
  "block.minecraft.banner.cross.blue": "Синій косий хрест",
  "block.minecraft.banner.cross.brown": "Коричневий косий хрест",
  "block.minecraft.banner.cross.cyan": "Бірюзовий косий хрест",
  "block.minecraft.banner.cross.gray": "Сірий косий хрест",
  "block.minecraft.banner.cross.green": "Зелений косий хрест",
  "block.minecraft.banner.cross.light_blue": "Блакитний косий хрест",
  "block.minecraft.banner.cross.light_gray": "Світло-сірий косий хрест",
  "block.minecraft.banner.cross.lime": "Лаймовий косий хрест",
  "block.minecraft.banner.cross.magenta": "Пурпуровий косий хрест",
  "block.minecraft.banner.cross.orange": "Помаранчевий косий хрест",
  "block.minecraft.banner.cross.pink": "Рожевий косий хрест",
  "block.minecraft.banner.cross.purple": "Фіолетовий косий хрест",
  "block.minecraft.banner.cross.red": "Червоний косий хрест",
  "block.minecraft.banner.cross.white": "Білий косий хрест",
  "block.minecraft.banner.cross.yellow": "Жовтий косий хрест",
  "block.minecraft.banner.curly_border.black": "Чорна зубчата рамка",
  "block.minecraft.banner.curly_border.blue": "Синя зубчата рамка",
  "block.minecraft.banner.curly_border.brown": "Коричнева зубчата рамка",
  "block.minecraft.banner.curly_border.cyan": "Бірюзова зубчата рамка",
  "block.minecraft.banner.curly_border.gray": "Сіра зубчата рамка",
  "block.minecraft.banner.curly_border.green": "Зелена зубчата рамка",
  "block.minecraft.banner.curly_border.light_blue": "Блакитна зубчата рамка",
  "block.minecraft.banner.curly_border.light_gray": "Світло-сіра зубчата рамка",
  "block.minecraft.banner.curly_border.lime": "Лаймова зубчата рамка",
  "block.minecraft.banner.curly_border.magenta": "Пурпурова зубчата рамка",
  "block.minecraft.banner.curly_border.orange": "Помаранчева зубчата рамка",
  "block.minecraft.banner.curly_border.pink": "Рожева зубчата рамка",
  "block.minecraft.banner.curly_border.purple": "Фіолетова зубчата рамка",
  "block.minecraft.banner.curly_border.red": "Червона зубчата рамка",
  "block.minecraft.banner.curly_border.white": "Біла зубчата рамка",
  "block.minecraft.banner.curly_border.yellow": "Жовта зубчата рамка",
  "block.minecraft.banner.diagonal_left.black": "Чорна верхня ліва половина",
  "block.minecraft.banner.diagonal_left.blue": "Синя верхня ліва половина",
  "block.minecraft.banner.diagonal_left.brown": "Коричнева верхня ліва половина",
  "block.minecraft.banner.diagonal_left.cyan": "Бірюзова верхня ліва половина",
  "block.minecraft.banner.diagonal_left.gray": "Сіра верхня ліва половина",
  "block.minecraft.banner.diagonal_left.green": "Зелена верхня ліва половина",
  "block.minecraft.banner.diagonal_left.light_blue": "Блакитна верхня ліва половина",
  "block.minecraft.banner.diagonal_left.light_gray": "Світло-сіра верхня ліва половина",
  "block.minecraft.banner.diagonal_left.lime": "Лаймова верхня ліва половина",
  "block.minecraft.banner.diagonal_left.magenta": "Пурпурова верхня ліва половина",
  "block.minecraft.banner.diagonal_left.orange": "Помаранчева верхня ліва половина",
  "block.minecraft.banner.diagonal_left.pink": "Рожева верхня ліва половина",
  "block.minecraft.banner.diagonal_left.purple": "Фіолетова верхня ліва половина",
  "block.minecraft.banner.diagonal_left.red": "Червона верхня ліва половина",
  "block.minecraft.banner.diagonal_left.white": "Біла верхня ліва половина",
  "block.minecraft.banner.diagonal_left.yellow": "Жовта верхня ліва половина",
  "block.minecraft.banner.diagonal_right.black": "Чорна верхня права половина",
  "block.minecraft.banner.diagonal_right.blue": "Синя верхня права половина",
  "block.minecraft.banner.diagonal_right.brown": "Коричнева верхня права половина",
  "block.minecraft.banner.diagonal_right.cyan": "Бірюзова верхня права половина",
  "block.minecraft.banner.diagonal_right.gray": "Сіра верхня права половина",
  "block.minecraft.banner.diagonal_right.green": "Зелена верхня права половина",
  "block.minecraft.banner.diagonal_right.light_blue": "Блакитна верхня права половина",
  "block.minecraft.banner.diagonal_right.light_gray": "Світло-сіра верхня права половина",
  "block.minecraft.banner.diagonal_right.lime": "Лаймова верхня права половина",
  "block.minecraft.banner.diagonal_right.magenta": "Пурпурова верхня права половина",
  "block.minecraft.banner.diagonal_right.orange": "Помаранчева верхня права половина",
  "block.minecraft.banner.diagonal_right.pink": "Рожева верхня права половина",
  "block.minecraft.banner.diagonal_right.purple": "Фіолетова верхня права половина",
  "block.minecraft.banner.diagonal_right.red": "Червона верхня права половина",
  "block.minecraft.banner.diagonal_right.white": "Біла верхня права половина",
  "block.minecraft.banner.diagonal_right.yellow": "Жовта верхня права половина",
  "block.minecraft.banner.diagonal_up_left.black": "Чорна нижня ліва половина",
  "block.minecraft.banner.diagonal_up_left.blue": "Синя нижня ліва половина",
  "block.minecraft.banner.diagonal_up_left.brown": "Коричнева нижня ліва половина",
  "block.minecraft.banner.diagonal_up_left.cyan": "Бірюзова нижня ліва половина",
  "block.minecraft.banner.diagonal_up_left.gray": "Сіра нижня ліва половина",
  "block.minecraft.banner.diagonal_up_left.green": "Зелена нижня ліва половина",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Блакитна нижня ліва половина",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Світло-сіра нижня ліва половина",
  "block.minecraft.banner.diagonal_up_left.lime": "Лаймова нижня ліва половина",
  "block.minecraft.banner.diagonal_up_left.magenta": "Пурпурова нижня ліва половина",
  "block.minecraft.banner.diagonal_up_left.orange": "Помаранчева нижня ліва половина",
  "block.minecraft.banner.diagonal_up_left.pink": "Рожева нижня ліва половина",
  "block.minecraft.banner.diagonal_up_left.purple": "Фіолетова нижня ліва половина",
  "block.minecraft.banner.diagonal_up_left.red": "Червона нижня ліва половина",
  "block.minecraft.banner.diagonal_up_left.white": "Біла нижня ліва половина",
  "block.minecraft.banner.diagonal_up_left.yellow": "Жовта нижня ліва половина",
  "block.minecraft.banner.diagonal_up_right.black": "Чорна нижня права половина",
  "block.minecraft.banner.diagonal_up_right.blue": "Синя нижня права половина",
  "block.minecraft.banner.diagonal_up_right.brown": "Коричнева нижня права половина",
  "block.minecraft.banner.diagonal_up_right.cyan": "Бірюзова нижня права половина",
  "block.minecraft.banner.diagonal_up_right.gray": "Сіра нижня права половина",
  "block.minecraft.banner.diagonal_up_right.green": "Зелена нижня права половина",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Блакитна нижня права половина",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Світло-сіра нижня права половина",
  "block.minecraft.banner.diagonal_up_right.lime": "Лаймова нижня права половина",
  "block.minecraft.banner.diagonal_up_right.magenta": "Пурпурова нижня права половина",
  "block.minecraft.banner.diagonal_up_right.orange": "Помаранчева нижня права половина",
  "block.minecraft.banner.diagonal_up_right.pink": "Рожева нижня права половина",
  "block.minecraft.banner.diagonal_up_right.purple": "Фіолетова нижня права половина",
  "block.minecraft.banner.diagonal_up_right.red": "Червона нижня права половина",
  "block.minecraft.banner.diagonal_up_right.white": "Біла нижня права половина",
  "block.minecraft.banner.diagonal_up_right.yellow": "Жовта нижня права половина",
  "block.minecraft.banner.flow.black": "Чорний плин",
  "block.minecraft.banner.flow.blue": "Синій плин",
  "block.minecraft.banner.flow.brown": "Коричневий плин",
  "block.minecraft.banner.flow.cyan": "Бірюзовий плин",
  "block.minecraft.banner.flow.gray": "Сірий плин",
  "block.minecraft.banner.flow.green": "Зелений плин",
  "block.minecraft.banner.flow.light_blue": "Блакитний плин",
  "block.minecraft.banner.flow.light_gray": "Світло-сірий плин",
  "block.minecraft.banner.flow.lime": "Лаймовий плин",
  "block.minecraft.banner.flow.magenta": "Пурпуровий плин",
  "block.minecraft.banner.flow.orange": "Помаранчевий плин",
  "block.minecraft.banner.flow.pink": "Рожевий плин",
  "block.minecraft.banner.flow.purple": "Фіолетовий плин",
  "block.minecraft.banner.flow.red": "Червоний плин",
  "block.minecraft.banner.flow.white": "Білий плин",
  "block.minecraft.banner.flow.yellow": "Жовтий плин",
  "block.minecraft.banner.flower.black": "Чорна емблема квітки",
  "block.minecraft.banner.flower.blue": "Синя емблема квітки",
  "block.minecraft.banner.flower.brown": "Коричнева емблема квітки",
  "block.minecraft.banner.flower.cyan": "Бірюзова емблема квітки",
  "block.minecraft.banner.flower.gray": "Сіра емблема квітки",
  "block.minecraft.banner.flower.green": "Зелена емблема квітки",
  "block.minecraft.banner.flower.light_blue": "Блакитна емблема квітки",
  "block.minecraft.banner.flower.light_gray": "Світло-сіра емблема квітки",
  "block.minecraft.banner.flower.lime": "Лаймова емблема квітки",
  "block.minecraft.banner.flower.magenta": "Пурпурова емблема квітки",
  "block.minecraft.banner.flower.orange": "Помаранчева емблема квітки",
  "block.minecraft.banner.flower.pink": "Рожева емблема квітки",
  "block.minecraft.banner.flower.purple": "Фіолетова емблема квітки",
  "block.minecraft.banner.flower.red": "Червона емблема квітки",
  "block.minecraft.banner.flower.white": "Біла емблема квітки",
  "block.minecraft.banner.flower.yellow": "Жовта емблема квітки",
  "block.minecraft.banner.globe.black": "Чорний глобус",
  "block.minecraft.banner.globe.blue": "Синій глобус",
  "block.minecraft.banner.globe.brown": "Коричневий глобус",
  "block.minecraft.banner.globe.cyan": "Бірюзовий глобус",
  "block.minecraft.banner.globe.gray": "Сірий глобус",
  "block.minecraft.banner.globe.green": "Зелений глобус",
  "block.minecraft.banner.globe.light_blue": "Блакитний глобус",
  "block.minecraft.banner.globe.light_gray": "Світло-сірий глобус",
  "block.minecraft.banner.globe.lime": "Лаймовий глобус",
  "block.minecraft.banner.globe.magenta": "Пурпуровий глобус",
  "block.minecraft.banner.globe.orange": "Помаранчевий глобус",
  "block.minecraft.banner.globe.pink": "Рожевий глобус",
  "block.minecraft.banner.globe.purple": "Фіолетовий глобус",
  "block.minecraft.banner.globe.red": "Червоний глобус",
  "block.minecraft.banner.globe.white": "Білий глобус",
  "block.minecraft.banner.globe.yellow": "Жовтий глобус",
  "block.minecraft.banner.gradient.black": "Чорний градієнт згори",
  "block.minecraft.banner.gradient.blue": "Синій градієнт згори",
  "block.minecraft.banner.gradient.brown": "Коричневий градієнт згори",
  "block.minecraft.banner.gradient.cyan": "Бірюзовий градієнт згори",
  "block.minecraft.banner.gradient.gray": "Сірий градієнт згори",
  "block.minecraft.banner.gradient.green": "Зелений градієнт згори",
  "block.minecraft.banner.gradient.light_blue": "Блакитний градієнт згори",
  "block.minecraft.banner.gradient.light_gray": "Світло-сірий градієнт згори",
  "block.minecraft.banner.gradient.lime": "Лаймовий градієнт згори",
  "block.minecraft.banner.gradient.magenta": "Пурпуровий градієнт згори",
  "block.minecraft.banner.gradient.orange": "Помаранчевий градієнт згори",
  "block.minecraft.banner.gradient.pink": "Рожевий градієнт згори",
  "block.minecraft.banner.gradient.purple": "Фіолетовий градієнт згори",
  "block.minecraft.banner.gradient.red": "Червоний градієнт згори",
  "block.minecraft.banner.gradient.white": "Білий градієнт згори",
  "block.minecraft.banner.gradient.yellow": "Жовтий градієнт згори",
  "block.minecraft.banner.gradient_up.black": "Чорний градієнт знизу",
  "block.minecraft.banner.gradient_up.blue": "Синій градієнт знизу",
  "block.minecraft.banner.gradient_up.brown": "Коричневий градієнт знизу",
  "block.minecraft.banner.gradient_up.cyan": "Бірюзовий градієнт знизу",
  "block.minecraft.banner.gradient_up.gray": "Сірий градієнт знизу",
  "block.minecraft.banner.gradient_up.green": "Зелений градієнт знизу",
  "block.minecraft.banner.gradient_up.light_blue": "Блакитний градієнт знизу",
  "block.minecraft.banner.gradient_up.light_gray": "Світло-сірий градієнт знизу",
  "block.minecraft.banner.gradient_up.lime": "Лаймовий градієнт знизу",
  "block.minecraft.banner.gradient_up.magenta": "Пурпуровий градієнт знизу",
  "block.minecraft.banner.gradient_up.orange": "Помаранчевий градієнт знизу",
  "block.minecraft.banner.gradient_up.pink": "Рожевий градієнт знизу",
  "block.minecraft.banner.gradient_up.purple": "Фіолетовий градієнт знизу",
  "block.minecraft.banner.gradient_up.red": "Червоний градієнт знизу",
  "block.minecraft.banner.gradient_up.white": "Білий градієнт знизу",
  "block.minecraft.banner.gradient_up.yellow": "Жовтий градієнт знизу",
  "block.minecraft.banner.guster.black": "Чорний порив",
  "block.minecraft.banner.guster.blue": "Синій порив",
  "block.minecraft.banner.guster.brown": "Коричневий порив",
  "block.minecraft.banner.guster.cyan": "Бірюзовий порив",
  "block.minecraft.banner.guster.gray": "Сірий порив",
  "block.minecraft.banner.guster.green": "Зелений порив",
  "block.minecraft.banner.guster.light_blue": "Блакитний порив",
  "block.minecraft.banner.guster.light_gray": "Світло-сірий порив",
  "block.minecraft.banner.guster.lime": "Лаймовий порив",
  "block.minecraft.banner.guster.magenta": "Пурпуровий порив",
  "block.minecraft.banner.guster.orange": "Помаранчевий порив",
  "block.minecraft.banner.guster.pink": "Рожевий порив",
  "block.minecraft.banner.guster.purple": "Фіолетовий порив",
  "block.minecraft.banner.guster.red": "Червоний порив",
  "block.minecraft.banner.guster.white": "Білий порив",
  "block.minecraft.banner.guster.yellow": "Жовтий порив",
  "block.minecraft.banner.half_horizontal.black": "Чорна верхня половина",
  "block.minecraft.banner.half_horizontal.blue": "Синя верхня половина",
  "block.minecraft.banner.half_horizontal.brown": "Коричнева верхня половина",
  "block.minecraft.banner.half_horizontal.cyan": "Бірюзова верхня половина",
  "block.minecraft.banner.half_horizontal.gray": "Сіра верхня половина",
  "block.minecraft.banner.half_horizontal.green": "Зелена верхня половина",
  "block.minecraft.banner.half_horizontal.light_blue": "Блакитна верхня половина",
  "block.minecraft.banner.half_horizontal.light_gray": "Світло-сіра верхня половина",
  "block.minecraft.banner.half_horizontal.lime": "Лаймова верхня половина",
  "block.minecraft.banner.half_horizontal.magenta": "Пурпурова верхня половина",
  "block.minecraft.banner.half_horizontal.orange": "Помаранчева верхня половина",
  "block.minecraft.banner.half_horizontal.pink": "Рожева верхня половина",
  "block.minecraft.banner.half_horizontal.purple": "Фіолетова верхня половина",
  "block.minecraft.banner.half_horizontal.red": "Червона верхня половина",
  "block.minecraft.banner.half_horizontal.white": "Біла верхня половина",
  "block.minecraft.banner.half_horizontal.yellow": "Жовта верхня половина",
  "block.minecraft.banner.half_horizontal_bottom.black": "Чорна нижня половина",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Синя нижня половина",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Коричнева нижня половина",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Бірюзова нижня половина",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Сіра нижня половина",
  "block.minecraft.banner.half_horizontal_bottom.green": "Зелена нижня половина",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Блакитна нижня половина",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Світло-сіра нижня половина",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Лаймова нижня половина",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Пурпурова нижня половина",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Помаранчева нижня половина",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Рожева нижня половина",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Фіолетова нижня половина",
  "block.minecraft.banner.half_horizontal_bottom.red": "Червона нижня половина",
  "block.minecraft.banner.half_horizontal_bottom.white": "Біла нижня половина",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Жовта нижня половина",
  "block.minecraft.banner.half_vertical.black": "Чорна ліва половина",
  "block.minecraft.banner.half_vertical.blue": "Синя ліва половина",
  "block.minecraft.banner.half_vertical.brown": "Коричнева ліва половина",
  "block.minecraft.banner.half_vertical.cyan": "Бірюзова ліва половина",
  "block.minecraft.banner.half_vertical.gray": "Сіра ліва половина",
  "block.minecraft.banner.half_vertical.green": "Зелена ліва половина",
  "block.minecraft.banner.half_vertical.light_blue": "Блакитна ліва половина",
  "block.minecraft.banner.half_vertical.light_gray": "Світло-сіра ліва половина",
  "block.minecraft.banner.half_vertical.lime": "Лаймова ліва половина",
  "block.minecraft.banner.half_vertical.magenta": "Пурпурова ліва половина",
  "block.minecraft.banner.half_vertical.orange": "Помаранчева ліва половина",
  "block.minecraft.banner.half_vertical.pink": "Рожева ліва половина",
  "block.minecraft.banner.half_vertical.purple": "Фіолетова ліва половина",
  "block.minecraft.banner.half_vertical.red": "Червона ліва половина",
  "block.minecraft.banner.half_vertical.white": "Біла ліва половина",
  "block.minecraft.banner.half_vertical.yellow": "Жовта ліва половина",
  "block.minecraft.banner.half_vertical_right.black": "Чорна права половина",
  "block.minecraft.banner.half_vertical_right.blue": "Синя права половина",
  "block.minecraft.banner.half_vertical_right.brown": "Коричнева права половина",
  "block.minecraft.banner.half_vertical_right.cyan": "Бірюзова права половина",
  "block.minecraft.banner.half_vertical_right.gray": "Сіра права половина",
  "block.minecraft.banner.half_vertical_right.green": "Зелена права половина",
  "block.minecraft.banner.half_vertical_right.light_blue": "Блакитна права половина",
  "block.minecraft.banner.half_vertical_right.light_gray": "Світло-сіра права половина",
  "block.minecraft.banner.half_vertical_right.lime": "Лаймова права половина",
  "block.minecraft.banner.half_vertical_right.magenta": "Пурпурова права половина",
  "block.minecraft.banner.half_vertical_right.orange": "Помаранчева права половина",
  "block.minecraft.banner.half_vertical_right.pink": "Рожева права половина",
  "block.minecraft.banner.half_vertical_right.purple": "Фіолетова права половина",
  "block.minecraft.banner.half_vertical_right.red": "Червона права половина",
  "block.minecraft.banner.half_vertical_right.white": "Біла права половина",
  "block.minecraft.banner.half_vertical_right.yellow": "Жовта права половина",
  "block.minecraft.banner.mojang.black": "Чорна річ",
  "block.minecraft.banner.mojang.blue": "Синя річ",
  "block.minecraft.banner.mojang.brown": "Коричнева річ",
  "block.minecraft.banner.mojang.cyan": "Бірюзова річ",
  "block.minecraft.banner.mojang.gray": "Сіра річ",
  "block.minecraft.banner.mojang.green": "Зелена річ",
  "block.minecraft.banner.mojang.light_blue": "Блакитна річ",
  "block.minecraft.banner.mojang.light_gray": "Світло-сіра річ",
  "block.minecraft.banner.mojang.lime": "Лаймова річ",
  "block.minecraft.banner.mojang.magenta": "Пурпурова річ",
  "block.minecraft.banner.mojang.orange": "Помаранчева річ",
  "block.minecraft.banner.mojang.pink": "Рожева річ",
  "block.minecraft.banner.mojang.purple": "Фіолетова річ",
  "block.minecraft.banner.mojang.red": "Червона річ",
  "block.minecraft.banner.mojang.white": "Біла річ",
  "block.minecraft.banner.mojang.yellow": "Жовта річ",
  "block.minecraft.banner.piglin.black": "Чорне рило",
  "block.minecraft.banner.piglin.blue": "Синє рило",
  "block.minecraft.banner.piglin.brown": "Коричневе рило",
  "block.minecraft.banner.piglin.cyan": "Бірюзове рило",
  "block.minecraft.banner.piglin.gray": "Сіре рило",
  "block.minecraft.banner.piglin.green": "Зелене рило",
  "block.minecraft.banner.piglin.light_blue": "Блакитне рило",
  "block.minecraft.banner.piglin.light_gray": "Світло-сіре рило",
  "block.minecraft.banner.piglin.lime": "Лаймове рило",
  "block.minecraft.banner.piglin.magenta": "Пурпурове рило",
  "block.minecraft.banner.piglin.orange": "Помаранчеве рило",
  "block.minecraft.banner.piglin.pink": "Рожеве рило",
  "block.minecraft.banner.piglin.purple": "Фіолетове рило",
  "block.minecraft.banner.piglin.red": "Червоне рило",
  "block.minecraft.banner.piglin.white": "Біле рило",
  "block.minecraft.banner.piglin.yellow": "Жовте рило",
  "block.minecraft.banner.rhombus.black": "Чорний ромб",
  "block.minecraft.banner.rhombus.blue": "Синій ромб",
  "block.minecraft.banner.rhombus.brown": "Коричневий ромб",
  "block.minecraft.banner.rhombus.cyan": "Бірюзовий ромб",
  "block.minecraft.banner.rhombus.gray": "Сірий ромб",
  "block.minecraft.banner.rhombus.green": "Зелений ромб",
  "block.minecraft.banner.rhombus.light_blue": "Блакитний ромб",
  "block.minecraft.banner.rhombus.light_gray": "Світло-сірий ромб",
  "block.minecraft.banner.rhombus.lime": "Лаймовий ромб",
  "block.minecraft.banner.rhombus.magenta": "Пурпуровий ромб",
  "block.minecraft.banner.rhombus.orange": "Помаранчевий ромб",
  "block.minecraft.banner.rhombus.pink": "Рожевий ромб",
  "block.minecraft.banner.rhombus.purple": "Фіолетовий ромб",
  "block.minecraft.banner.rhombus.red": "Червоний ромб",
  "block.minecraft.banner.rhombus.white": "Білий ромб",
  "block.minecraft.banner.rhombus.yellow": "Жовтий ромб",
  "block.minecraft.banner.skull.black": "Чорна емблема черепа",
  "block.minecraft.banner.skull.blue": "Синя емблема черепа",
  "block.minecraft.banner.skull.brown": "Коричнева емблема черепа",
  "block.minecraft.banner.skull.cyan": "Бірюзова емблема черепа",
  "block.minecraft.banner.skull.gray": "Сіра емблема черепа",
  "block.minecraft.banner.skull.green": "Зелена емблема черепа",
  "block.minecraft.banner.skull.light_blue": "Блакитна емблема черепа",
  "block.minecraft.banner.skull.light_gray": "Світло-сіра емблема черепа",
  "block.minecraft.banner.skull.lime": "Лаймова емблема черепа",
  "block.minecraft.banner.skull.magenta": "Пурпурова емблема черепа",
  "block.minecraft.banner.skull.orange": "Помаранчева емблема черепа",
  "block.minecraft.banner.skull.pink": "Рожева емблема черепа",
  "block.minecraft.banner.skull.purple": "Фіолетова емблема черепа",
  "block.minecraft.banner.skull.red": "Червона емблема черепа",
  "block.minecraft.banner.skull.white": "Біла емблема черепа",
  "block.minecraft.banner.skull.yellow": "Жовта емблема черепа",
  "block.minecraft.banner.small_stripes.black": "Чорні вертикальні смуги",
  "block.minecraft.banner.small_stripes.blue": "Сині вертикальні смуги",
  "block.minecraft.banner.small_stripes.brown": "Коричневі вертикальні смуги",
  "block.minecraft.banner.small_stripes.cyan": "Бірюзові вертикальні смуги",
  "block.minecraft.banner.small_stripes.gray": "Сірі вертикальні смуги",
  "block.minecraft.banner.small_stripes.green": "Зелені вертикальні смуги",
  "block.minecraft.banner.small_stripes.light_blue": "Блакитні вертикальні смуги",
  "block.minecraft.banner.small_stripes.light_gray": "Світло-сірі вертикальні смуги",
  "block.minecraft.banner.small_stripes.lime": "Лаймові вертикальні смуги",
  "block.minecraft.banner.small_stripes.magenta": "Пурпурові вертикальні смуги",
  "block.minecraft.banner.small_stripes.orange": "Помаранчеві вертикальні смуги",
  "block.minecraft.banner.small_stripes.pink": "Рожеві вертикальні смуги",
  "block.minecraft.banner.small_stripes.purple": "Фіолетові вертикальні смуги",
  "block.minecraft.banner.small_stripes.red": "Червоні вертикальні смуги",
  "block.minecraft.banner.small_stripes.white": "Білі вертикальні смуги",
  "block.minecraft.banner.small_stripes.yellow": "Жовті вертикальні смуги",
  "block.minecraft.banner.square_bottom_left.black": "Чорний криж зліва знизу",
  "block.minecraft.banner.square_bottom_left.blue": "Синій криж зліва знизу",
  "block.minecraft.banner.square_bottom_left.brown": "Коричневий криж зліва знизу",
  "block.minecraft.banner.square_bottom_left.cyan": "Бірюзовий криж зліва знизу",
  "block.minecraft.banner.square_bottom_left.gray": "Сірий криж зліва знизу",
  "block.minecraft.banner.square_bottom_left.green": "Зелений криж зліва знизу",
  "block.minecraft.banner.square_bottom_left.light_blue": "Блакитний криж зліва знизу",
  "block.minecraft.banner.square_bottom_left.light_gray": "Світло-сірий криж зліва знизу",
  "block.minecraft.banner.square_bottom_left.lime": "Лаймовий криж зліва знизу",
  "block.minecraft.banner.square_bottom_left.magenta": "Пурпуровий криж зліва знизу",
  "block.minecraft.banner.square_bottom_left.orange": "Помаранчевий криж зліва знизу",
  "block.minecraft.banner.square_bottom_left.pink": "Рожевий криж зліва знизу",
  "block.minecraft.banner.square_bottom_left.purple": "Фіолетовий криж зліва знизу",
  "block.minecraft.banner.square_bottom_left.red": "Червоний криж зліва знизу",
  "block.minecraft.banner.square_bottom_left.white": "Білий криж зліва знизу",
  "block.minecraft.banner.square_bottom_left.yellow": "Жовтий криж зліва знизу",
  "block.minecraft.banner.square_bottom_right.black": "Чорний криж справа знизу",
  "block.minecraft.banner.square_bottom_right.blue": "Синій криж справа знизу",
  "block.minecraft.banner.square_bottom_right.brown": "Коричневий криж справа знизу",
  "block.minecraft.banner.square_bottom_right.cyan": "Бірюзовий криж справа знизу",
  "block.minecraft.banner.square_bottom_right.gray": "Сірий криж справа знизу",
  "block.minecraft.banner.square_bottom_right.green": "Зелений криж справа знизу",
  "block.minecraft.banner.square_bottom_right.light_blue": "Блакитний криж справа знизу",
  "block.minecraft.banner.square_bottom_right.light_gray": "Світло-сірий криж справа знизу",
  "block.minecraft.banner.square_bottom_right.lime": "Лаймовий криж справа знизу",
  "block.minecraft.banner.square_bottom_right.magenta": "Пурпуровий криж справа знизу",
  "block.minecraft.banner.square_bottom_right.orange": "Помаранчевий криж справа знизу",
  "block.minecraft.banner.square_bottom_right.pink": "Рожевий криж справа знизу",
  "block.minecraft.banner.square_bottom_right.purple": "Фіолетовий криж справа знизу",
  "block.minecraft.banner.square_bottom_right.red": "Червоний криж справа знизу",
  "block.minecraft.banner.square_bottom_right.white": "Білий криж справа знизу",
  "block.minecraft.banner.square_bottom_right.yellow": "Жовтий криж справа знизу",
  "block.minecraft.banner.square_top_left.black": "Чорний криж зліва згори",
  "block.minecraft.banner.square_top_left.blue": "Синій криж зліва згори",
  "block.minecraft.banner.square_top_left.brown": "Коричневий криж зліва згори",
  "block.minecraft.banner.square_top_left.cyan": "Бірюзовий криж зліва згори",
  "block.minecraft.banner.square_top_left.gray": "Сірий криж зліва згори",
  "block.minecraft.banner.square_top_left.green": "Зелений криж зліва згори",
  "block.minecraft.banner.square_top_left.light_blue": "Блакитний криж зліва згори",
  "block.minecraft.banner.square_top_left.light_gray": "Світло-сірий криж зліва згори",
  "block.minecraft.banner.square_top_left.lime": "Лаймовий криж зліва згори",
  "block.minecraft.banner.square_top_left.magenta": "Пурпуровий криж зліва згори",
  "block.minecraft.banner.square_top_left.orange": "Помаранчевий криж зліва згори",
  "block.minecraft.banner.square_top_left.pink": "Рожевий криж зліва згори",
  "block.minecraft.banner.square_top_left.purple": "Фіолетовий криж зліва згори",
  "block.minecraft.banner.square_top_left.red": "Червоний криж зліва згори",
  "block.minecraft.banner.square_top_left.white": "Білий криж зліва згори",
  "block.minecraft.banner.square_top_left.yellow": "Жовтий криж зліва згори",
  "block.minecraft.banner.square_top_right.black": "Чорний криж справа згори",
  "block.minecraft.banner.square_top_right.blue": "Синій криж справа згори",
  "block.minecraft.banner.square_top_right.brown": "Коричневий криж справа згори",
  "block.minecraft.banner.square_top_right.cyan": "Бірюзовий криж справа згори",
  "block.minecraft.banner.square_top_right.gray": "Сірий криж справа згори",
  "block.minecraft.banner.square_top_right.green": "Зелений криж справа згори",
  "block.minecraft.banner.square_top_right.light_blue": "Блакитний криж справа згори",
  "block.minecraft.banner.square_top_right.light_gray": "Світло-сірий криж справа згори",
  "block.minecraft.banner.square_top_right.lime": "Лаймовий криж справа згори",
  "block.minecraft.banner.square_top_right.magenta": "Пурпуровий криж справа згори",
  "block.minecraft.banner.square_top_right.orange": "Помаранчевий криж справа згори",
  "block.minecraft.banner.square_top_right.pink": "Рожевий криж справа згори",
  "block.minecraft.banner.square_top_right.purple": "Фіолетовий криж справа згори",
  "block.minecraft.banner.square_top_right.red": "Червоний криж справа згори",
  "block.minecraft.banner.square_top_right.white": "Білий криж справа згори",
  "block.minecraft.banner.square_top_right.yellow": "Жовтий криж справа згори",
  "block.minecraft.banner.straight_cross.black": "Чорний хрест",
  "block.minecraft.banner.straight_cross.blue": "Синій хрест",
  "block.minecraft.banner.straight_cross.brown": "Коричневий хрест",
  "block.minecraft.banner.straight_cross.cyan": "Бірюзовий хрест",
  "block.minecraft.banner.straight_cross.gray": "Сірий хрест",
  "block.minecraft.banner.straight_cross.green": "Зелений хрест",
  "block.minecraft.banner.straight_cross.light_blue": "Блакитний хрест",
  "block.minecraft.banner.straight_cross.light_gray": "Світло-сірий хрест",
  "block.minecraft.banner.straight_cross.lime": "Лаймовий хрест",
  "block.minecraft.banner.straight_cross.magenta": "Пурпуровий хрест",
  "block.minecraft.banner.straight_cross.orange": "Помаранчевий хрест",
  "block.minecraft.banner.straight_cross.pink": "Рожевий хрест",
  "block.minecraft.banner.straight_cross.purple": "Фіолетовий хрест",
  "block.minecraft.banner.straight_cross.red": "Червоний хрест",
  "block.minecraft.banner.straight_cross.white": "Білий хрест",
  "block.minecraft.banner.straight_cross.yellow": "Жовтий хрест",
  "block.minecraft.banner.stripe_bottom.black": "Чорна основа",
  "block.minecraft.banner.stripe_bottom.blue": "Синя основа",
  "block.minecraft.banner.stripe_bottom.brown": "Коричнева основа",
  "block.minecraft.banner.stripe_bottom.cyan": "Бірюзова основа",
  "block.minecraft.banner.stripe_bottom.gray": "Сіра основа",
  "block.minecraft.banner.stripe_bottom.green": "Зелена основа",
  "block.minecraft.banner.stripe_bottom.light_blue": "Блакитна основа",
  "block.minecraft.banner.stripe_bottom.light_gray": "Світло-сіра основа",
  "block.minecraft.banner.stripe_bottom.lime": "Лаймова основа",
  "block.minecraft.banner.stripe_bottom.magenta": "Пурпурова основа",
  "block.minecraft.banner.stripe_bottom.orange": "Помаранчева основа",
  "block.minecraft.banner.stripe_bottom.pink": "Рожева основа",
  "block.minecraft.banner.stripe_bottom.purple": "Фіолетова основа",
  "block.minecraft.banner.stripe_bottom.red": "Червона основа",
  "block.minecraft.banner.stripe_bottom.white": "Біла основа",
  "block.minecraft.banner.stripe_bottom.yellow": "Жовта основа",
  "block.minecraft.banner.stripe_center.black": "Чорний стовп",
  "block.minecraft.banner.stripe_center.blue": "Синій стовп",
  "block.minecraft.banner.stripe_center.brown": "Коричневий стовп",
  "block.minecraft.banner.stripe_center.cyan": "Бірюзовий стовп",
  "block.minecraft.banner.stripe_center.gray": "Сірий стовп",
  "block.minecraft.banner.stripe_center.green": "Зелений стовп",
  "block.minecraft.banner.stripe_center.light_blue": "Блакитний стовп",
  "block.minecraft.banner.stripe_center.light_gray": "Світло-сірий стовп",
  "block.minecraft.banner.stripe_center.lime": "Лаймовий стовп",
  "block.minecraft.banner.stripe_center.magenta": "Пурпуровий стовп",
  "block.minecraft.banner.stripe_center.orange": "Помаранчевий стовп",
  "block.minecraft.banner.stripe_center.pink": "Рожевий стовп",
  "block.minecraft.banner.stripe_center.purple": "Фіолетовий стовп",
  "block.minecraft.banner.stripe_center.red": "Червоний стовп",
  "block.minecraft.banner.stripe_center.white": "Білий стовп",
  "block.minecraft.banner.stripe_center.yellow": "Жовтий стовп",
  "block.minecraft.banner.stripe_downleft.black": "Чорна діагональ справа наліво",
  "block.minecraft.banner.stripe_downleft.blue": "Синя діагональ справа наліво",
  "block.minecraft.banner.stripe_downleft.brown": "Коричнева діагональ справа наліво",
  "block.minecraft.banner.stripe_downleft.cyan": "Бірюзова діагональ справа наліво",
  "block.minecraft.banner.stripe_downleft.gray": "Сіра діагональ справа наліво",
  "block.minecraft.banner.stripe_downleft.green": "Зелена діагональ справа наліво",
  "block.minecraft.banner.stripe_downleft.light_blue": "Блакитна діагональ справа наліво",
  "block.minecraft.banner.stripe_downleft.light_gray": "Світло-сіра діагональ справа наліво",
  "block.minecraft.banner.stripe_downleft.lime": "Лаймова діагональ справа наліво",
  "block.minecraft.banner.stripe_downleft.magenta": "Пурпурова діагональ справа наліво",
  "block.minecraft.banner.stripe_downleft.orange": "Помаранчева діагональ справа наліво",
  "block.minecraft.banner.stripe_downleft.pink": "Рожева діагональ справа наліво",
  "block.minecraft.banner.stripe_downleft.purple": "Фіолетова діагональ справа наліво",
  "block.minecraft.banner.stripe_downleft.red": "Червона діагональ справа наліво",
  "block.minecraft.banner.stripe_downleft.white": "Біла діагональ справа наліво",
  "block.minecraft.banner.stripe_downleft.yellow": "Жовта діагональ справа наліво",
  "block.minecraft.banner.stripe_downright.black": "Чорна діагональ зліва направо",
  "block.minecraft.banner.stripe_downright.blue": "Синя діагональ зліва направо",
  "block.minecraft.banner.stripe_downright.brown": "Коричнева діагональ зліва направо",
  "block.minecraft.banner.stripe_downright.cyan": "Бірюзова діагональ зліва направо",
  "block.minecraft.banner.stripe_downright.gray": "Сіра діагональ зліва направо",
  "block.minecraft.banner.stripe_downright.green": "Зелена діагональ зліва направо",
  "block.minecraft.banner.stripe_downright.light_blue": "Блакитна діагональ зліва направо",
  "block.minecraft.banner.stripe_downright.light_gray": "Світло-сіра діагональ зліва направо",
  "block.minecraft.banner.stripe_downright.lime": "Лаймова діагональ зліва направо",
  "block.minecraft.banner.stripe_downright.magenta": "Пурпурова діагональ зліва направо",
  "block.minecraft.banner.stripe_downright.orange": "Помаранчева діагональ зліва направо",
  "block.minecraft.banner.stripe_downright.pink": "Рожева діагональ зліва направо",
  "block.minecraft.banner.stripe_downright.purple": "Фіолетова діагональ зліва направо",
  "block.minecraft.banner.stripe_downright.red": "Червона діагональ зліва направо",
  "block.minecraft.banner.stripe_downright.white": "Біла діагональ зліва направо",
  "block.minecraft.banner.stripe_downright.yellow": "Жовта діагональ зліва направо",
  "block.minecraft.banner.stripe_left.black": "Чорна вертикальна смуга зліва",
  "block.minecraft.banner.stripe_left.blue": "Синя вертикальна смуга зліва",
  "block.minecraft.banner.stripe_left.brown": "Коричнева вертикальна смуга зліва",
  "block.minecraft.banner.stripe_left.cyan": "Бірюзова вертикальна смуга зліва",
  "block.minecraft.banner.stripe_left.gray": "Сіра вертикальна смуга зліва",
  "block.minecraft.banner.stripe_left.green": "Зелена вертикальна смуга зліва",
  "block.minecraft.banner.stripe_left.light_blue": "Блакитна вертикальна смуга зліва",
  "block.minecraft.banner.stripe_left.light_gray": "Світло-сіра вертикальна смуга зліва",
  "block.minecraft.banner.stripe_left.lime": "Лаймова вертикальна смуга зліва",
  "block.minecraft.banner.stripe_left.magenta": "Пурпурова вертикальна смуга зліва",
  "block.minecraft.banner.stripe_left.orange": "Помаранчева вертикальна смуга зліва",
  "block.minecraft.banner.stripe_left.pink": "Рожева вертикальна смуга зліва",
  "block.minecraft.banner.stripe_left.purple": "Фіолетова вертикальна смуга зліва",
  "block.minecraft.banner.stripe_left.red": "Червона вертикальна смуга зліва",
  "block.minecraft.banner.stripe_left.white": "Біла вертикальна смуга зліва",
  "block.minecraft.banner.stripe_left.yellow": "Жовта вертикальна смуга зліва",
  "block.minecraft.banner.stripe_middle.black": "Чорний пояс",
  "block.minecraft.banner.stripe_middle.blue": "Синій пояс",
  "block.minecraft.banner.stripe_middle.brown": "Коричневий пояс",
  "block.minecraft.banner.stripe_middle.cyan": "Бірюзовий пояс",
  "block.minecraft.banner.stripe_middle.gray": "Сірий пояс",
  "block.minecraft.banner.stripe_middle.green": "Зелений пояс",
  "block.minecraft.banner.stripe_middle.light_blue": "Блакитний пояс",
  "block.minecraft.banner.stripe_middle.light_gray": "Світло-сірий пояс",
  "block.minecraft.banner.stripe_middle.lime": "Лаймовий пояс",
  "block.minecraft.banner.stripe_middle.magenta": "Пурпуровий пояс",
  "block.minecraft.banner.stripe_middle.orange": "Помаранчевий пояс",
  "block.minecraft.banner.stripe_middle.pink": "Рожевий пояс",
  "block.minecraft.banner.stripe_middle.purple": "Фіолетовий пояс",
  "block.minecraft.banner.stripe_middle.red": "Червоний пояс",
  "block.minecraft.banner.stripe_middle.white": "Білий пояс",
  "block.minecraft.banner.stripe_middle.yellow": "Жовтий пояс",
  "block.minecraft.banner.stripe_right.black": "Чорна вертикальна смуга справа",
  "block.minecraft.banner.stripe_right.blue": "Синя вертикальна смуга справа",
  "block.minecraft.banner.stripe_right.brown": "Коричнева вертикальна смуга справа",
  "block.minecraft.banner.stripe_right.cyan": "Бірюзова вертикальна смуга справа",
  "block.minecraft.banner.stripe_right.gray": "Сіра вертикальна смуга справа",
  "block.minecraft.banner.stripe_right.green": "Зелена вертикальна смуга справа",
  "block.minecraft.banner.stripe_right.light_blue": "Блакитна вертикальна смуга справа",
  "block.minecraft.banner.stripe_right.light_gray": "Світло-сіра вертикальна смуга справа",
  "block.minecraft.banner.stripe_right.lime": "Лаймова вертикальна смуга справа",
  "block.minecraft.banner.stripe_right.magenta": "Пурпурова вертикальна смуга справа",
  "block.minecraft.banner.stripe_right.orange": "Помаранчева вертикальна смуга справа",
  "block.minecraft.banner.stripe_right.pink": "Рожева вертикальна смуга справа",
  "block.minecraft.banner.stripe_right.purple": "Фіолетова вертикальна смуга справа",
  "block.minecraft.banner.stripe_right.red": "Червона вертикальна смуга справа",
  "block.minecraft.banner.stripe_right.white": "Біла вертикальна смуга справа",
  "block.minecraft.banner.stripe_right.yellow": "Жовта вертикальна смуга справа",
  "block.minecraft.banner.stripe_top.black": "Чорний верх",
  "block.minecraft.banner.stripe_top.blue": "Синій верх",
  "block.minecraft.banner.stripe_top.brown": "Коричневий верх",
  "block.minecraft.banner.stripe_top.cyan": "Бірюзовий верх",
  "block.minecraft.banner.stripe_top.gray": "Сірий верх",
  "block.minecraft.banner.stripe_top.green": "Зелений верх",
  "block.minecraft.banner.stripe_top.light_blue": "Блакитний верх",
  "block.minecraft.banner.stripe_top.light_gray": "Світло-сірий верх",
  "block.minecraft.banner.stripe_top.lime": "Лаймовий верх",
  "block.minecraft.banner.stripe_top.magenta": "Пурпуровий верх",
  "block.minecraft.banner.stripe_top.orange": "Помаранчевий верх",
  "block.minecraft.banner.stripe_top.pink": "Рожевий верх",
  "block.minecraft.banner.stripe_top.purple": "Фіолетовий верх",
  "block.minecraft.banner.stripe_top.red": "Червоний верх",
  "block.minecraft.banner.stripe_top.white": "Білий верх",
  "block.minecraft.banner.stripe_top.yellow": "Жовтий верх",
  "block.minecraft.banner.triangle_bottom.black": "Чорний шеврон знизу",
  "block.minecraft.banner.triangle_bottom.blue": "Синій шеврон знизу",
  "block.minecraft.banner.triangle_bottom.brown": "Коричневий шеврон знизу",
  "block.minecraft.banner.triangle_bottom.cyan": "Бірюзовий шеврон знизу",
  "block.minecraft.banner.triangle_bottom.gray": "Сірий шеврон знизу",
  "block.minecraft.banner.triangle_bottom.green": "Зелений шеврон знизу",
  "block.minecraft.banner.triangle_bottom.light_blue": "Блакитний шеврон знизу",
  "block.minecraft.banner.triangle_bottom.light_gray": "Світло-сірий шеврон знизу",
  "block.minecraft.banner.triangle_bottom.lime": "Лаймовий шеврон знизу",
  "block.minecraft.banner.triangle_bottom.magenta": "Пурпуровий шеврон знизу",
  "block.minecraft.banner.triangle_bottom.orange": "Помаранчевий шеврон знизу",
  "block.minecraft.banner.triangle_bottom.pink": "Рожевий шеврон знизу",
  "block.minecraft.banner.triangle_bottom.purple": "Фіолетовий шеврон знизу",
  "block.minecraft.banner.triangle_bottom.red": "Червоний шеврон знизу",
  "block.minecraft.banner.triangle_bottom.white": "Білий шеврон знизу",
  "block.minecraft.banner.triangle_bottom.yellow": "Жовтий шеврон знизу",
  "block.minecraft.banner.triangle_top.black": "Чорний шеврон згори",
  "block.minecraft.banner.triangle_top.blue": "Синій шеврон згори",
  "block.minecraft.banner.triangle_top.brown": "Коричневий шеврон згори",
  "block.minecraft.banner.triangle_top.cyan": "Бірюзовий шеврон згори",
  "block.minecraft.banner.triangle_top.gray": "Сірий шеврон згори",
  "block.minecraft.banner.triangle_top.green": "Зелений шеврон згори",
  "block.minecraft.banner.triangle_top.light_blue": "Блакитний шеврон згори",
  "block.minecraft.banner.triangle_top.light_gray": "Світло-сірий шеврон згори",
  "block.minecraft.banner.triangle_top.lime": "Лаймовий шеврон згори",
  "block.minecraft.banner.triangle_top.magenta": "Пурпуровий шеврон згори",
  "block.minecraft.banner.triangle_top.orange": "Помаранчевий шеврон згори",
  "block.minecraft.banner.triangle_top.pink": "Рожевий шеврон згори",
  "block.minecraft.banner.triangle_top.purple": "Фіолетовий шеврон згори",
  "block.minecraft.banner.triangle_top.red": "Червоний шеврон згори",
  "block.minecraft.banner.triangle_top.white": "Білий шеврон згори",
  "block.minecraft.banner.triangle_top.yellow": "Жовтий шеврон згори",
  "block.minecraft.banner.triangles_bottom.black": "Чорні зубці знизу",
  "block.minecraft.banner.triangles_bottom.blue": "Сині зубці знизу",
  "block.minecraft.banner.triangles_bottom.brown": "Коричневі зубці знизу",
  "block.minecraft.banner.triangles_bottom.cyan": "Бірюзові зубці знизу",
  "block.minecraft.banner.triangles_bottom.gray": "Сірі зубці знизу",
  "block.minecraft.banner.triangles_bottom.green": "Зелені зубці знизу",
  "block.minecraft.banner.triangles_bottom.light_blue": "Блакитні зубці знизу",
  "block.minecraft.banner.triangles_bottom.light_gray": "Світло-сірі зубці знизу",
  "block.minecraft.banner.triangles_bottom.lime": "Лаймові зубці знизу",
  "block.minecraft.banner.triangles_bottom.magenta": "Пурпурові зубці знизу",
  "block.minecraft.banner.triangles_bottom.orange": "Помаранчеві зубці знизу",
  "block.minecraft.banner.triangles_bottom.pink": "Рожеві зубці знизу",
  "block.minecraft.banner.triangles_bottom.purple": "Фіолетові зубці знизу",
  "block.minecraft.banner.triangles_bottom.red": "Червоні зубці знизу",
  "block.minecraft.banner.triangles_bottom.white": "Білі зубці знизу",
  "block.minecraft.banner.triangles_bottom.yellow": "Жовті зубці знизу",
  "block.minecraft.banner.triangles_top.black": "Чорні зубці згори",
  "block.minecraft.banner.triangles_top.blue": "Сині зубці згори",
  "block.minecraft.banner.triangles_top.brown": "Коричневі зубці згори",
  "block.minecraft.banner.triangles_top.cyan": "Бірюзові зубці згори",
  "block.minecraft.banner.triangles_top.gray": "Сірі зубці згори",
  "block.minecraft.banner.triangles_top.green": "Зелені зубці згори",
  "block.minecraft.banner.triangles_top.light_blue": "Блакитні зубці згори",
  "block.minecraft.banner.triangles_top.light_gray": "Світло-сірі зубці згори",
  "block.minecraft.banner.triangles_top.lime": "Лаймові зубці згори",
  "block.minecraft.banner.triangles_top.magenta": "Пурпурові зубці згори",
  "block.minecraft.banner.triangles_top.orange": "Помаранчеві зубці згори",
  "block.minecraft.banner.triangles_top.pink": "Рожеві зубці згори",
  "block.minecraft.banner.triangles_top.purple": "Фіолетові зубці згори",
  "block.minecraft.banner.triangles_top.red": "Червоні зубці згори",
  "block.minecraft.banner.triangles_top.white": "Білі зубці згори",
  "block.minecraft.banner.triangles_top.yellow": "Жовті зубці згори",
  "block.minecraft.barrel": "Діжка",
  "block.minecraft.barrier": "Бар'єр",
  "block.minecraft.basalt": "Базальт",
  "block.minecraft.beacon": "Маяк",
  "block.minecraft.beacon.primary": "Первинна сила",
  "block.minecraft.beacon.secondary": "Вторинна сила",
  "block.minecraft.bed.no_sleep": "Ви можете спати лише вночі або під час грози",
  "block.minecraft.bed.not_safe": "Ви не можете зараз спати: поблизу є монстри",
  "block.minecraft.bed.obstructed": "Це ліжко заблоковане",
  "block.minecraft.bed.occupied": "Це ліжко зайняте",
  "block.minecraft.bed.too_far_away": "Ви не можете зараз спати: ліжко занадто далеко",
  "block.minecraft.bedrock": "Корінна порода",
  "block.minecraft.bee_nest": "Бджолине гніздо",
  "block.minecraft.beehive": "Вулик",
  "block.minecraft.beetroots": "Буряк",
  "block.minecraft.bell": "Дзвін",
  "block.minecraft.big_dripleaf": "Великий краплелист",
  "block.minecraft.big_dripleaf_stem": "Стебло великого краплелиста",
  "block.minecraft.birch_button": "Березова кнопка",
  "block.minecraft.birch_door": "Березові двері",
  "block.minecraft.birch_fence": "Березовий паркан",
  "block.minecraft.birch_fence_gate": "Березова хвіртка",
  "block.minecraft.birch_hanging_sign": "Березова вивіска",
  "block.minecraft.birch_leaves": "Березове листя",
  "block.minecraft.birch_log": "Березова колода",
  "block.minecraft.birch_planks": "Березові дошки",
  "block.minecraft.birch_pressure_plate": "Березова натискна плита",
  "block.minecraft.birch_sapling": "Паросток берези",
  "block.minecraft.birch_shelf": "Березова полиця",
  "block.minecraft.birch_sign": "Березова табличка",
  "block.minecraft.birch_slab": "Березова плита",
  "block.minecraft.birch_stairs": "Березові сходи",
  "block.minecraft.birch_trapdoor": "Березовий люк",
  "block.minecraft.birch_wall_hanging_sign": "Березова настінна вивіска",
  "block.minecraft.birch_wall_sign": "Березова настінна табличка",
  "block.minecraft.birch_wood": "Березова деревина",
  "block.minecraft.black_banner": "Чорний стяг",
  "block.minecraft.black_bed": "Чорне ліжко",
  "block.minecraft.black_candle": "Чорна свічка",
  "block.minecraft.black_candle_cake": "Торт із чорною свічкою",
  "block.minecraft.black_carpet": "Чорний килим",
  "block.minecraft.black_concrete": "Чорний бетон",
  "block.minecraft.black_concrete_powder": "Чорний цемент",
  "block.minecraft.black_glazed_terracotta": "Чорна глазурована кераміка",
  "block.minecraft.black_shulker_box": "Чорна шалкерова коробка",
  "block.minecraft.black_stained_glass": "Чорне скло",
  "block.minecraft.black_stained_glass_pane": "Чорна шибка",
  "block.minecraft.black_terracotta": "Чорна кераміка",
  "block.minecraft.black_wool": "Чорна вовна",
  "block.minecraft.blackstone": "Чорнокамінь",
  "block.minecraft.blackstone_slab": "Чорнокам'яна плита",
  "block.minecraft.blackstone_stairs": "Чорнокам'яні сходи",
  "block.minecraft.blackstone_wall": "Чорнокам'яна стіна",
  "block.minecraft.blast_furnace": "Домна",
  "block.minecraft.blue_banner": "Синій стяг",
  "block.minecraft.blue_bed": "Синє ліжко",
  "block.minecraft.blue_candle": "Синя свічка",
  "block.minecraft.blue_candle_cake": "Торт із синьою свічкою",
  "block.minecraft.blue_carpet": "Синій килим",
  "block.minecraft.blue_concrete": "Синій бетон",
  "block.minecraft.blue_concrete_powder": "Синій цемент",
  "block.minecraft.blue_glazed_terracotta": "Синя глазурована кераміка",
  "block.minecraft.blue_ice": "Синій лід",
  "block.minecraft.blue_orchid": "Синя орхідея",
  "block.minecraft.blue_shulker_box": "Синя шалкерова коробка",
  "block.minecraft.blue_stained_glass": "Синє скло",
  "block.minecraft.blue_stained_glass_pane": "Синя шибка",
  "block.minecraft.blue_terracotta": "Синя кераміка",
  "block.minecraft.blue_wool": "Синя вовна",
  "block.minecraft.bone_block": "Кістяний блок",
  "block.minecraft.bookshelf": "Книжкова полиця",
  "block.minecraft.brain_coral": "Мозковий корал",
  "block.minecraft.brain_coral_block": "Блок мозкового корала",
  "block.minecraft.brain_coral_fan": "Віяло з мозкових коралів",
  "block.minecraft.brain_coral_wall_fan": "Настінне віяло з мозкових коралів",
  "block.minecraft.brewing_stand": "Варильна стійка",
  "block.minecraft.brick_slab": "Цегляна плита",
  "block.minecraft.brick_stairs": "Цегляні сходи",
  "block.minecraft.brick_wall": "Цегляна стіна",
  "block.minecraft.bricks": "Цегла",
  "block.minecraft.brown_banner": "Коричневий стяг",
  "block.minecraft.brown_bed": "Коричневе ліжко",
  "block.minecraft.brown_candle": "Коричнева свічка",
  "block.minecraft.brown_candle_cake": "Торт із коричневою свічкою",
  "block.minecraft.brown_carpet": "Коричневий килим",
  "block.minecraft.brown_concrete": "Коричневий бетон",
  "block.minecraft.brown_concrete_powder": "Коричневий цемент",
  "block.minecraft.brown_glazed_terracotta": "Коричнева глазурована кераміка",
  "block.minecraft.brown_mushroom": "Коричневий гриб",
  "block.minecraft.brown_mushroom_block": "Блок коричневого гриба",
  "block.minecraft.brown_shulker_box": "Коричнева шалкерова коробка",
  "block.minecraft.brown_stained_glass": "Коричневе скло",
  "block.minecraft.brown_stained_glass_pane": "Коричнева шибка",
  "block.minecraft.brown_terracotta": "Коричнева кераміка",
  "block.minecraft.brown_wool": "Коричнева вовна",
  "block.minecraft.bubble_column": "Колона бульбашок",
  "block.minecraft.bubble_coral": "Бульбашковий корал",
  "block.minecraft.bubble_coral_block": "Блок бульбашкового корала",
  "block.minecraft.bubble_coral_fan": "Віяло з бульбашкових коралів",
  "block.minecraft.bubble_coral_wall_fan": "Настінне віяло з бульбашкових коралів",
  "block.minecraft.budding_amethyst": "Родючий аметист",
  "block.minecraft.bush": "Кущ",
  "block.minecraft.cactus": "Кактус",
  "block.minecraft.cactus_flower": "Квітка кактуса",
  "block.minecraft.cake": "Торт",
  "block.minecraft.calcite": "Кальцит",
  "block.minecraft.calibrated_sculk_sensor": "Відкалібрований скалковий сенсор",
  "block.minecraft.campfire": "Багаття",
  "block.minecraft.candle": "Свічка",
  "block.minecraft.candle_cake": "Торт зі свічкою",
  "block.minecraft.carrots": "Морква",
  "block.minecraft.cartography_table": "Картографічний стіл",
  "block.minecraft.carved_pumpkin": "Вирізаний гарбуз",
  "block.minecraft.cauldron": "Казан",
  "block.minecraft.cave_air": "Печерне повітря",
  "block.minecraft.cave_vines": "Печерні лози",
  "block.minecraft.cave_vines_plant": "Стебло печерних ліз",
  "block.minecraft.chain": "Ланцюг",
  "block.minecraft.chain_command_block": "Ланцюговий командний блок",
  "block.minecraft.cherry_button": "Вишнева кнопка",
  "block.minecraft.cherry_door": "Вишневі двері",
  "block.minecraft.cherry_fence": "Вишневий паркан",
  "block.minecraft.cherry_fence_gate": "Вишнева хвіртка",
  "block.minecraft.cherry_hanging_sign": "Вишнева вивіска",
  "block.minecraft.cherry_leaves": "Вишневе листя",
  "block.minecraft.cherry_log": "Вишнева колода",
  "block.minecraft.cherry_planks": "Вишневі дошки",
  "block.minecraft.cherry_pressure_plate": "Вишнева натискна плита",
  "block.minecraft.cherry_sapling": "Паросток вишні",
  "block.minecraft.cherry_shelf": "Вишнева полиця",
  "block.minecraft.cherry_sign": "Вишнева табличка",
  "block.minecraft.cherry_slab": "Вишнева плита",
  "block.minecraft.cherry_stairs": "Вишневі сходи",
  "block.minecraft.cherry_trapdoor": "Вишневий люк",
  "block.minecraft.cherry_wall_hanging_sign": "Вишнева настінна вивіска",
  "block.minecraft.cherry_wall_sign": "Вишнева настінна табличка",
  "block.minecraft.cherry_wood": "Вишнева деревина",
  "block.minecraft.chest": "Скриня",
  "block.minecraft.chipped_anvil": "Надщерблене ковадло",
  "block.minecraft.chiseled_bookshelf": "Різьблена книжкова полиця",
  "block.minecraft.chiseled_copper": "Різьблена мідь",
  "block.minecraft.chiseled_deepslate": "Різьблений глибосланець",
  "block.minecraft.chiseled_nether_bricks": "Різьблена незерська цегла",
  "block.minecraft.chiseled_polished_blackstone": "Різьблений полірований чорнокамінь",
  "block.minecraft.chiseled_quartz_block": "Різьблений кварцовий блок",
  "block.minecraft.chiseled_red_sandstone": "Різьблений червоний пісковик",
  "block.minecraft.chiseled_resin_bricks": "Різьблена смоляна цегла",
  "block.minecraft.chiseled_sandstone": "Різьблений пісковик",
  "block.minecraft.chiseled_stone_bricks": "Різьблена кам'яна цегла",
  "block.minecraft.chiseled_tuff": "Різьблений туф",
  "block.minecraft.chiseled_tuff_bricks": "Різьблена туфова цегла",
  "block.minecraft.chorus_flower": "Квітка хорусу",
  "block.minecraft.chorus_plant": "Рослина хорусу",
  "block.minecraft.clay": "Глина",
  "block.minecraft.closed_eyeblossom": "Закритий окоцвіт",
  "block.minecraft.coal_block": "Блок вугілля",
  "block.minecraft.coal_ore": "Вугільна руда",
  "block.minecraft.coarse_dirt": "Загрубілий ґрунт",
  "block.minecraft.cobbled_deepslate": "Глибосланцевий кругляк",
  "block.minecraft.cobbled_deepslate_slab": "Плита з глибосланцевого кругляку",
  "block.minecraft.cobbled_deepslate_stairs": "Сходи з глибосланцевого кругляку",
  "block.minecraft.cobbled_deepslate_wall": "Стіна з глибосланцевого кругляку",
  "block.minecraft.cobblestone": "Кругляк",
  "block.minecraft.cobblestone_slab": "Плита з кругляку",
  "block.minecraft.cobblestone_stairs": "Сходи з кругляку",
  "block.minecraft.cobblestone_wall": "Стіна з кругляку",
  "block.minecraft.cobweb": "Павутиння",
  "block.minecraft.cocoa": "Какао",
  "block.minecraft.command_block": "Командний блок",
  "block.minecraft.comparator": "Редстоуновий компаратор",
  "block.minecraft.composter": "Компостер",
  "block.minecraft.conduit": "Провідник",
  "block.minecraft.copper_bars": "Мідні ґрати",
  "block.minecraft.copper_block": "Блок міді",
  "block.minecraft.copper_bulb": "Мідна жарівка",
  "block.minecraft.copper_chain": "Мідний ланцюг",
  "block.minecraft.copper_chest": "Мідна скриня",
  "block.minecraft.copper_door": "Мідні двері",
  "block.minecraft.copper_golem_statue": "Статуя мідного ґолема",
  "block.minecraft.copper_grate": "Мідна решітка",
  "block.minecraft.copper_lantern": "Мідний ліхтар",
  "block.minecraft.copper_ore": "Мідна руда",
  "block.minecraft.copper_torch": "Мідний смолоскип",
  "block.minecraft.copper_trapdoor": "Мідний люк",
  "block.minecraft.copper_wall_torch": "Мідний настінний смолоскип",
  "block.minecraft.cornflower": "Волошка",
  "block.minecraft.cracked_deepslate_bricks": "Тріснута глибосланцева цегла",
  "block.minecraft.cracked_deepslate_tiles": "Тріснуті глибосланцеві кахлі",
  "block.minecraft.cracked_nether_bricks": "Тріснута незерська цегла",
  "block.minecraft.cracked_polished_blackstone_bricks": "Тріснута полірована чорнокам'яна цегла",
  "block.minecraft.cracked_stone_bricks": "Тріснута кам'яна цегла",
  "block.minecraft.crafter": "Майструвач",
  "block.minecraft.crafting_table": "Верстак",
  "block.minecraft.creaking_heart": "Серце скрипня",
  "block.minecraft.creeper_head": "Голова кріпера",
  "block.minecraft.creeper_wall_head": "Настінна голова кріпера",
  "block.minecraft.crimson_button": "Багряна кнопка",
  "block.minecraft.crimson_door": "Багряні двері",
  "block.minecraft.crimson_fence": "Багряний паркан",
  "block.minecraft.crimson_fence_gate": "Багряна хвіртка",
  "block.minecraft.crimson_fungus": "Багряний гриб",
  "block.minecraft.crimson_hanging_sign": "Багряна вивіска",
  "block.minecraft.crimson_hyphae": "Багряні гіфи",
  "block.minecraft.crimson_nylium": "Багряний нілій",
  "block.minecraft.crimson_planks": "Багряні дошки",
  "block.minecraft.crimson_pressure_plate": "Багряна натискна плита",
  "block.minecraft.crimson_roots": "Багряне коріння",
  "block.minecraft.crimson_shelf": "Багряна полиця",
  "block.minecraft.crimson_sign": "Багряна табличка",
  "block.minecraft.crimson_slab": "Багряна плита",
  "block.minecraft.crimson_stairs": "Багряні сходи",
  "block.minecraft.crimson_stem": "Багряна ніжка",
  "block.minecraft.crimson_trapdoor": "Багряний люк",
  "block.minecraft.crimson_wall_hanging_sign": "Багряна настінна вивіска",
  "block.minecraft.crimson_wall_sign": "Багряна настінна табличка",
  "block.minecraft.crying_obsidian": "Плакучий обсидіан",
  "block.minecraft.cut_copper": "Тесана мідь",
  "block.minecraft.cut_copper_slab": "Тесана мідна плита",
  "block.minecraft.cut_copper_stairs": "Тесані мідні сходи",
  "block.minecraft.cut_red_sandstone": "Тесаний червоний пісковик",
  "block.minecraft.cut_red_sandstone_slab": "Плита з тесаного червоного пісковику",
  "block.minecraft.cut_sandstone": "Тесаний пісковик",
  "block.minecraft.cut_sandstone_slab": "Плита з тесаного пісковику",
  "block.minecraft.cyan_banner": "Бірюзовий стяг",
  "block.minecraft.cyan_bed": "Бірюзове ліжко",
  "block.minecraft.cyan_candle": "Бірюзова свічка",
  "block.minecraft.cyan_candle_cake": "Торт із бірюзовою свічкою",
  "block.minecraft.cyan_carpet": "Бірюзовий килим",
  "block.minecraft.cyan_concrete": "Бірюзовий бетон",
  "block.minecraft.cyan_concrete_powder": "Бірюзовий цемент",
  "block.minecraft.cyan_glazed_terracotta": "Бірюзова глазурована кераміка",
  "block.minecraft.cyan_shulker_box": "Бірюзова шалкерова коробка",
  "block.minecraft.cyan_stained_glass": "Бірюзове скло",
  "block.minecraft.cyan_stained_glass_pane": "Бірюзова шибка",
  "block.minecraft.cyan_terracotta": "Бірюзова кераміка",
  "block.minecraft.cyan_wool": "Бірюзова вовна",
  "block.minecraft.damaged_anvil": "Пошкоджене ковадло",
  "block.minecraft.dandelion": "Кульбаба",
  "block.minecraft.dark_oak_button": "Темно-дубова кнопка",
  "block.minecraft.dark_oak_door": "Темно-дубові двері",
  "block.minecraft.dark_oak_fence": "Темно-дубовий паркан",
  "block.minecraft.dark_oak_fence_gate": "Темно-дубова хвіртка",
  "block.minecraft.dark_oak_hanging_sign": "Темно-дубова вивіска",
  "block.minecraft.dark_oak_leaves": "Темно-дубове листя",
  "block.minecraft.dark_oak_log": "Темно-дубова колода",
  "block.minecraft.dark_oak_planks": "Темно-дубові дошки",
  "block.minecraft.dark_oak_pressure_plate": "Темно-дубова натискна плита",
  "block.minecraft.dark_oak_sapling": "Паросток темного дуба",
  "block.minecraft.dark_oak_shelf": "Темно-дубова полиця",
  "block.minecraft.dark_oak_sign": "Темно-дубова табличка",
  "block.minecraft.dark_oak_slab": "Темно-дубова плита",
  "block.minecraft.dark_oak_stairs": "Темно-дубові сходи",
  "block.minecraft.dark_oak_trapdoor": "Темно-дубовий люк",
  "block.minecraft.dark_oak_wall_hanging_sign": "Темно-дубова настінна вивіска",
  "block.minecraft.dark_oak_wall_sign": "Темно-дубова настінна табличка",
  "block.minecraft.dark_oak_wood": "Темно-дубова деревина",
  "block.minecraft.dark_prismarine": "Темний призмарин",
  "block.minecraft.dark_prismarine_slab": "Плита з темного призмарину",
  "block.minecraft.dark_prismarine_stairs": "Сходи з темного призмарину",
  "block.minecraft.daylight_detector": "Детектор денного світла",
  "block.minecraft.dead_brain_coral": "Мертвий мозковий корал",
  "block.minecraft.dead_brain_coral_block": "Блок мертвого мозкового корала",
  "block.minecraft.dead_brain_coral_fan": "Віяло з мертвих мозкових коралів",
  "block.minecraft.dead_brain_coral_wall_fan": "Настінне віяло з мертвих мозкових коралів",
  "block.minecraft.dead_bubble_coral": "Мертвий бульбашковий корал",
  "block.minecraft.dead_bubble_coral_block": "Блок мертвого бульбашкового корала",
  "block.minecraft.dead_bubble_coral_fan": "Віяло з мертвих бульбашкових коралів",
  "block.minecraft.dead_bubble_coral_wall_fan": "Настінне віяло з мертвих бульбашкових коралів",
  "block.minecraft.dead_bush": "Мертвий кущ",
  "block.minecraft.dead_fire_coral": "Мертвий вогняний корал",
  "block.minecraft.dead_fire_coral_block": "Блок мертвого вогняного корала",
  "block.minecraft.dead_fire_coral_fan": "Віяло з мертвих вогняних коралів",
  "block.minecraft.dead_fire_coral_wall_fan": "Настінне віяло з мертвих вогняних коралів",
  "block.minecraft.dead_horn_coral": "Мертвий роговий корал",
  "block.minecraft.dead_horn_coral_block": "Блок мертвого рогового корала",
  "block.minecraft.dead_horn_coral_fan": "Віяло з мертвих рогових коралів",
  "block.minecraft.dead_horn_coral_wall_fan": "Настінне віяло з мертвих рогових коралів",
  "block.minecraft.dead_tube_coral": "Мертвий трубчастий корал",
  "block.minecraft.dead_tube_coral_block": "Блок мертвого трубчастого корала",
  "block.minecraft.dead_tube_coral_fan": "Віяло з мертвих трубчастих коралів",
  "block.minecraft.dead_tube_coral_wall_fan": "Настінне віяло з мертвих трубчастих коралів",
  "block.minecraft.decorated_pot": "Оздоблений горщик",
  "block.minecraft.deepslate": "Глибосланець",
  "block.minecraft.deepslate_brick_slab": "Плита з глибосланцевої цегли",
  "block.minecraft.deepslate_brick_stairs": "Сходи з глибосланцевої цегли",
  "block.minecraft.deepslate_brick_wall": "Стіна з глибосланцевої цегли",
  "block.minecraft.deepslate_bricks": "Глибосланцева цегла",
  "block.minecraft.deepslate_coal_ore": "Глибосланцева вугільна руда",
  "block.minecraft.deepslate_copper_ore": "Глибосланцева мідна руда",
  "block.minecraft.deepslate_diamond_ore": "Глибосланцева діамантова руда",
  "block.minecraft.deepslate_emerald_ore": "Глибосланцева смарагдова руда",
  "block.minecraft.deepslate_gold_ore": "Глибосланцева золота руда",
  "block.minecraft.deepslate_iron_ore": "Глибосланцева залізна руда",
  "block.minecraft.deepslate_lapis_ore": "Глибосланцева лазуритова руда",
  "block.minecraft.deepslate_redstone_ore": "Глибосланцева редстоунова руда",
  "block.minecraft.deepslate_tile_slab": "Плита з глибосланцевих кахлів",
  "block.minecraft.deepslate_tile_stairs": "Сходи з глибосланцевих кахлів",
  "block.minecraft.deepslate_tile_wall": "Стіна з глибосланцевих кахлів",
  "block.minecraft.deepslate_tiles": "Глибосланцеві кахлі",
  "block.minecraft.detector_rail": "Детекторні рейки",
  "block.minecraft.diamond_block": "Блок діаманта",
  "block.minecraft.diamond_ore": "Діамантова руда",
  "block.minecraft.diorite": "Діорит",
  "block.minecraft.diorite_slab": "Діоритова плита",
  "block.minecraft.diorite_stairs": "Діоритові сходи",
  "block.minecraft.diorite_wall": "Діоритова стіна",
  "block.minecraft.dirt": "Ґрунт",
  "block.minecraft.dirt_path": "Ґрунтова стежка",
  "block.minecraft.dispenser": "Роздавач",
  "block.minecraft.dragon_egg": "Яйце дракона",
  "block.minecraft.dragon_head": "Голова дракона",
  "block.minecraft.dragon_wall_head": "Настінна голова дракона",
  "block.minecraft.dried_ghast": "Висушений ґаст",
  "block.minecraft.dried_kelp_block": "Блок висушеної ламінарії",
  "block.minecraft.dripstone_block": "Сталактитовий блок",
  "block.minecraft.dropper": "Викидач",
  "block.minecraft.emerald_block": "Блок смарагда",
  "block.minecraft.emerald_ore": "Смарагдова руда",
  "block.minecraft.enchanting_table": "Стіл зачарування",
  "block.minecraft.end_gateway": "Ворота Енду",
  "block.minecraft.end_portal": "Портал Енду",
  "block.minecraft.end_portal_frame": "Рамка порталу Енду",
  "block.minecraft.end_rod": "Стрижень Енду",
  "block.minecraft.end_stone": "Камінь Енду",
  "block.minecraft.end_stone_brick_slab": "Цегляна плита з каменю Енду",
  "block.minecraft.end_stone_brick_stairs": "Цегляні сходи з каменю Енду",
  "block.minecraft.end_stone_brick_wall": "Цегляна стіна з каменю Енду",
  "block.minecraft.end_stone_bricks": "Цегла з каменю Енду",
  "block.minecraft.ender_chest": "Скриня Енду",
  "block.minecraft.exposed_chiseled_copper": "Наражена різьблена мідь",
  "block.minecraft.exposed_copper": "Наражена мідь",
  "block.minecraft.exposed_copper_bars": "Наражені мідні ґрати",
  "block.minecraft.exposed_copper_bulb": "Наражена мідна жарівка",
  "block.minecraft.exposed_copper_chain": "Наражений мідний ланцюг",
  "block.minecraft.exposed_copper_chest": "Наражена мідна скриня",
  "block.minecraft.exposed_copper_door": "Наражені мідні двері",
  "block.minecraft.exposed_copper_golem_statue": "Наражена статуя мідного ґолема",
  "block.minecraft.exposed_copper_grate": "Наражена мідна решітка",
  "block.minecraft.exposed_copper_lantern": "Наражений мідний ліхтар",
  "block.minecraft.exposed_copper_trapdoor": "Наражений мідний люк",
  "block.minecraft.exposed_cut_copper": "Наражена тесана мідь",
  "block.minecraft.exposed_cut_copper_slab": "Наражена тесана мідна плита",
  "block.minecraft.exposed_cut_copper_stairs": "Наражені тесані мідні сходи",
  "block.minecraft.exposed_lightning_rod": "Наражений блискавковідвід",
  "block.minecraft.farmland": "Рілля",
  "block.minecraft.fern": "Папороть",
  "block.minecraft.fire": "Вогонь",
  "block.minecraft.fire_coral": "Вогняний корал",
  "block.minecraft.fire_coral_block": "Блок вогняного корала",
  "block.minecraft.fire_coral_fan": "Віяло з вогняних коралів",
  "block.minecraft.fire_coral_wall_fan": "Настінне віяло з вогняних коралів",
  "block.minecraft.firefly_bush": "Кущ зі світляками",
  "block.minecraft.fletching_table": "Стіл лучника",
  "block.minecraft.flower_pot": "Квітковий горщик",
  "block.minecraft.flowering_azalea": "Квітуча азалія",
  "block.minecraft.flowering_azalea_leaves": "Квітучо-азалієве листя",
  "block.minecraft.frogspawn": "Жаб'яча ікра",
  "block.minecraft.frosted_ice": "Талий лід",
  "block.minecraft.furnace": "Піч",
  "block.minecraft.gilded_blackstone": "Позолочений чорнокамінь",
  "block.minecraft.glass": "Скло",
  "block.minecraft.glass_pane": "Шибка",
  "block.minecraft.glow_lichen": "Світлолишайник",
  "block.minecraft.glowstone": "Світлокамінь",
  "block.minecraft.gold_block": "Блок золота",
  "block.minecraft.gold_ore": "Золота руда",
  "block.minecraft.golden_dandelion": "Золота кульбаба",
  "block.minecraft.granite": "Граніт",
  "block.minecraft.granite_slab": "Гранітна плита",
  "block.minecraft.granite_stairs": "Гранітні сходи",
  "block.minecraft.granite_wall": "Гранітна стіна",
  "block.minecraft.grass": "Трава",
  "block.minecraft.grass_block": "Трав'яний блок",
  "block.minecraft.gravel": "Гравій",
  "block.minecraft.gray_banner": "Сірий стяг",
  "block.minecraft.gray_bed": "Сіре ліжко",
  "block.minecraft.gray_candle": "Сіра свічка",
  "block.minecraft.gray_candle_cake": "Торт із сірою свічкою",
  "block.minecraft.gray_carpet": "Сірий килим",
  "block.minecraft.gray_concrete": "Сірий бетон",
  "block.minecraft.gray_concrete_powder": "Сірий цемент",
  "block.minecraft.gray_glazed_terracotta": "Сіра глазурована кераміка",
  "block.minecraft.gray_shulker_box": "Сіра шалкерова коробка",
  "block.minecraft.gray_stained_glass": "Сіре скло",
  "block.minecraft.gray_stained_glass_pane": "Сіра шибка",
  "block.minecraft.gray_terracotta": "Сіра кераміка",
  "block.minecraft.gray_wool": "Сіра вовна",
  "block.minecraft.green_banner": "Зелений стяг",
  "block.minecraft.green_bed": "Зелене ліжко",
  "block.minecraft.green_candle": "Зелена свічка",
  "block.minecraft.green_candle_cake": "Торт із зеленою свічкою",
  "block.minecraft.green_carpet": "Зелений килим",
  "block.minecraft.green_concrete": "Зелений бетон",
  "block.minecraft.green_concrete_powder": "Зелений цемент",
  "block.minecraft.green_glazed_terracotta": "Зелена глазурована кераміка",
  "block.minecraft.green_shulker_box": "Зелена шалкерова коробка",
  "block.minecraft.green_stained_glass": "Зелене скло",
  "block.minecraft.green_stained_glass_pane": "Зелена шибка",
  "block.minecraft.green_terracotta": "Зелена кераміка",
  "block.minecraft.green_wool": "Зелена вовна",
  "block.minecraft.grindstone": "Точило",
  "block.minecraft.hanging_roots": "Висяче коріння",
  "block.minecraft.hay_block": "Копиця соломи",
  "block.minecraft.heavy_core": "Важке ядро",
  "block.minecraft.heavy_weighted_pressure_plate": "Важка вагова плита",
  "block.minecraft.honey_block": "Медовий блок",
  "block.minecraft.honeycomb_block": "Блок медових стільників",
  "block.minecraft.hopper": "Лійка",
  "block.minecraft.horn_coral": "Роговий корал",
  "block.minecraft.horn_coral_block": "Блок рогового корала",
  "block.minecraft.horn_coral_fan": "Віяло з рогових коралів",
  "block.minecraft.horn_coral_wall_fan": "Настінне віяло з рогових коралів",
  "block.minecraft.ice": "Лід",
  "block.minecraft.infested_chiseled_stone_bricks": "Заражена різьблена кам'яна цегла",
  "block.minecraft.infested_cobblestone": "Заражений кругляк",
  "block.minecraft.infested_cracked_stone_bricks": "Заражена тріснута кам'яна цегла",
  "block.minecraft.infested_deepslate": "Заражений глибосланець",
  "block.minecraft.infested_mossy_stone_bricks": "Заражена моховита кам'яна цегла",
  "block.minecraft.infested_stone": "Заражений камінь",
  "block.minecraft.infested_stone_bricks": "Заражена кам'яна цегла",
  "block.minecraft.iron_bars": "Залізні ґрати",
  "block.minecraft.iron_block": "Блок заліза",
  "block.minecraft.iron_chain": "Залізний ланцюг",
  "block.minecraft.iron_door": "Залізні двері",
  "block.minecraft.iron_ore": "Залізна руда",
  "block.minecraft.iron_trapdoor": "Залізний люк",
  "block.minecraft.jack_o_lantern": "Ліхтар Джека",
  "block.minecraft.jigsaw": "Пазловий блок",
  "block.minecraft.jukebox": "Програвач",
  "block.minecraft.jungle_button": "Тропічна кнопка",
  "block.minecraft.jungle_door": "Тропічні двері",
  "block.minecraft.jungle_fence": "Тропічний паркан",
  "block.minecraft.jungle_fence_gate": "Тропічна хвіртка",
  "block.minecraft.jungle_hanging_sign": "Тропічна вивіска",
  "block.minecraft.jungle_leaves": "Тропічне листя",
  "block.minecraft.jungle_log": "Тропічна колода",
  "block.minecraft.jungle_planks": "Тропічні дошки",
  "block.minecraft.jungle_pressure_plate": "Тропічна натискна плита",
  "block.minecraft.jungle_sapling": "Паросток тропічного дерева",
  "block.minecraft.jungle_shelf": "Тропічна полиця",
  "block.minecraft.jungle_sign": "Тропічна табличка",
  "block.minecraft.jungle_slab": "Тропічна плита",
  "block.minecraft.jungle_stairs": "Тропічні сходи",
  "block.minecraft.jungle_trapdoor": "Тропічний люк",
  "block.minecraft.jungle_wall_hanging_sign": "Тропічна настінна вивіска",
  "block.minecraft.jungle_wall_sign": "Тропічна настінна табличка",
  "block.minecraft.jungle_wood": "Тропічна деревина",
  "block.minecraft.kelp": "Ламінарія",
  "block.minecraft.kelp_plant": "Стебло ламінарії",
  "block.minecraft.ladder": "Драбина",
  "block.minecraft.lantern": "Ліхтар",
  "block.minecraft.lapis_block": "Блок лазуриту",
  "block.minecraft.lapis_ore": "Лазуритова руда",
  "block.minecraft.large_amethyst_bud": "Великий зародок аметиста",
  "block.minecraft.large_fern": "Велика папороть",
  "block.minecraft.lava": "Лава",
  "block.minecraft.lava_cauldron": "Казан із лавою",
  "block.minecraft.leaf_litter": "Опале листя",
  "block.minecraft.lectern": "Катедра",
  "block.minecraft.lever": "Важіль",
  "block.minecraft.light": "Світло",
  "block.minecraft.light_blue_banner": "Блакитний стяг",
  "block.minecraft.light_blue_bed": "Блакитне ліжко",
  "block.minecraft.light_blue_candle": "Блакитна свічка",
  "block.minecraft.light_blue_candle_cake": "Торт із блакитною свічкою",
  "block.minecraft.light_blue_carpet": "Блакитний килим",
  "block.minecraft.light_blue_concrete": "Блакитний бетон",
  "block.minecraft.light_blue_concrete_powder": "Блакитний цемент",
  "block.minecraft.light_blue_glazed_terracotta": "Блакитна глазурована кераміка",
  "block.minecraft.light_blue_shulker_box": "Блакитна шалкерова коробка",
  "block.minecraft.light_blue_stained_glass": "Блакитне скло",
  "block.minecraft.light_blue_stained_glass_pane": "Блакитна шибка",
  "block.minecraft.light_blue_terracotta": "Блакитна кераміка",
  "block.minecraft.light_blue_wool": "Блакитна вовна",
  "block.minecraft.light_gray_banner": "Світло-сірий стяг",
  "block.minecraft.light_gray_bed": "Світло-сіре ліжко",
  "block.minecraft.light_gray_candle": "Світло-сіра свічка",
  "block.minecraft.light_gray_candle_cake": "Торт зі світло-сірою свічкою",
  "block.minecraft.light_gray_carpet": "Світло-сірий килим",
  "block.minecraft.light_gray_concrete": "Світло-сірий бетон",
  "block.minecraft.light_gray_concrete_powder": "Світло-сірий цемент",
  "block.minecraft.light_gray_glazed_terracotta": "Світло-сіра глазурована кераміка",
  "block.minecraft.light_gray_shulker_box": "Світло-сіра шалкерова коробка",
  "block.minecraft.light_gray_stained_glass": "Світло-сіре скло",
  "block.minecraft.light_gray_stained_glass_pane": "Світло-сіра шибка",
  "block.minecraft.light_gray_terracotta": "Світло-сіра кераміка",
  "block.minecraft.light_gray_wool": "Світло-сіра вовна",
  "block.minecraft.light_weighted_pressure_plate": "Легка вагова плита",
  "block.minecraft.lightning_rod": "Блискавковідвід",
  "block.minecraft.lilac": "Бузок",
  "block.minecraft.lily_of_the_valley": "Конвалія",
  "block.minecraft.lily_pad": "Латаття",
  "block.minecraft.lime_banner": "Лаймовий стяг",
  "block.minecraft.lime_bed": "Лаймове ліжко",
  "block.minecraft.lime_candle": "Лаймова свічка",
  "block.minecraft.lime_candle_cake": "Торт із лаймовою свічкою",
  "block.minecraft.lime_carpet": "Лаймовий килим",
  "block.minecraft.lime_concrete": "Лаймовий бетон",
  "block.minecraft.lime_concrete_powder": "Лаймовий цемент",
  "block.minecraft.lime_glazed_terracotta": "Лаймова глазурована кераміка",
  "block.minecraft.lime_shulker_box": "Лаймова шалкерова коробка",
  "block.minecraft.lime_stained_glass": "Лаймове скло",
  "block.minecraft.lime_stained_glass_pane": "Лаймова шибка",
  "block.minecraft.lime_terracotta": "Лаймова кераміка",
  "block.minecraft.lime_wool": "Лаймова вовна",
  "block.minecraft.lodestone": "Магнетит",
  "block.minecraft.loom": "Ткацький верстат",
  "block.minecraft.magenta_banner": "Пурпуровий стяг",
  "block.minecraft.magenta_bed": "Пурпурове ліжко",
  "block.minecraft.magenta_candle": "Пурпурова свічка",
  "block.minecraft.magenta_candle_cake": "Торт із пурпуровою свічкою",
  "block.minecraft.magenta_carpet": "Пурпуровий килим",
  "block.minecraft.magenta_concrete": "Пурпуровий бетон",
  "block.minecraft.magenta_concrete_powder": "Пурпуровий цемент",
  "block.minecraft.magenta_glazed_terracotta": "Пурпурова глазурована кераміка",
  "block.minecraft.magenta_shulker_box": "Пурпурова шалкерова коробка",
  "block.minecraft.magenta_stained_glass": "Пурпурове скло",
  "block.minecraft.magenta_stained_glass_pane": "Пурпурова шибка",
  "block.minecraft.magenta_terracotta": "Пурпурова кераміка",
  "block.minecraft.magenta_wool": "Пурпурова вовна",
  "block.minecraft.magma_block": "Магматичний блок",
  "block.minecraft.mangrove_button": "Мангрова кнопка",
  "block.minecraft.mangrove_door": "Мангрові двері",
  "block.minecraft.mangrove_fence": "Мангровий паркан",
  "block.minecraft.mangrove_fence_gate": "Мангрова хвіртка",
  "block.minecraft.mangrove_hanging_sign": "Мангрова вивіска",
  "block.minecraft.mangrove_leaves": "Мангрове листя",
  "block.minecraft.mangrove_log": "Мангрова колода",
  "block.minecraft.mangrove_planks": "Мангрові дошки",
  "block.minecraft.mangrove_pressure_plate": "Мангрова натискна плита",
  "block.minecraft.mangrove_propagule": "Мангровий живець",
  "block.minecraft.mangrove_roots": "Мангрове коріння",
  "block.minecraft.mangrove_shelf": "Мангрова полиця",
  "block.minecraft.mangrove_sign": "Мангрова табличка",
  "block.minecraft.mangrove_slab": "Мангрова плита",
  "block.minecraft.mangrove_stairs": "Мангрові сходи",
  "block.minecraft.mangrove_trapdoor": "Мангровий люк",
  "block.minecraft.mangrove_wall_hanging_sign": "Мангрова настінна вивіска",
  "block.minecraft.mangrove_wall_sign": "Мангрова настінна табличка",
  "block.minecraft.mangrove_wood": "Мангрова деревина",
  "block.minecraft.medium_amethyst_bud": "Середній зародок аметиста",
  "block.minecraft.melon": "Кавун",
  "block.minecraft.melon_stem": "Стебло кавуна",
  "block.minecraft.moss_block": "Моховий блок",
  "block.minecraft.moss_carpet": "Моховий покрив",
  "block.minecraft.mossy_cobblestone": "Моховитий кругляк",
  "block.minecraft.mossy_cobblestone_slab": "Плита з моховитого кругляку",
  "block.minecraft.mossy_cobblestone_stairs": "Сходи з моховитого кругляку",
  "block.minecraft.mossy_cobblestone_wall": "Стіна з моховитого кругляку",
  "block.minecraft.mossy_stone_brick_slab": "Плита з моховитої кам'яної цегли",
  "block.minecraft.mossy_stone_brick_stairs": "Сходи з моховитої кам'яної цегли",
  "block.minecraft.mossy_stone_brick_wall": "Стіна з моховитої кам'яної цегли",
  "block.minecraft.mossy_stone_bricks": "Моховита кам'яна цегла",
  "block.minecraft.moving_piston": "Рухомий поршень",
  "block.minecraft.mud": "Багно",
  "block.minecraft.mud_brick_slab": "Плита з лимпачу",
  "block.minecraft.mud_brick_stairs": "Сходи з лимпачу",
  "block.minecraft.mud_brick_wall": "Стіна з лимпачу",
  "block.minecraft.mud_bricks": "Лимпач",
  "block.minecraft.muddy_mangrove_roots": "Багнисте мангрове коріння",
  "block.minecraft.mushroom_stem": "Ніжка гриба",
  "block.minecraft.mycelium": "Грибниця",
  "block.minecraft.nether_brick_fence": "Паркан із незерської цегли",
  "block.minecraft.nether_brick_slab": "Плита з незерської цегли",
  "block.minecraft.nether_brick_stairs": "Сходи з незерської цегли",
  "block.minecraft.nether_brick_wall": "Стіна з незерської цегли",
  "block.minecraft.nether_bricks": "Незерська цегла",
  "block.minecraft.nether_gold_ore": "Незерська золота руда",
  "block.minecraft.nether_portal": "Портал Незеру",
  "block.minecraft.nether_quartz_ore": "Незерська кварцова руда",
  "block.minecraft.nether_sprouts": "Незерські паростки",
  "block.minecraft.nether_wart": "Незерський наріст",
  "block.minecraft.nether_wart_block": "Блок незерського наросту",
  "block.minecraft.netherite_block": "Блок незериту",
  "block.minecraft.netherrack": "Незерак",
  "block.minecraft.note_block": "Нотний блок",
  "block.minecraft.oak_button": "Дубова кнопка",
  "block.minecraft.oak_door": "Дубові двері",
  "block.minecraft.oak_fence": "Дубовий паркан",
  "block.minecraft.oak_fence_gate": "Дубова хвіртка",
  "block.minecraft.oak_hanging_sign": "Дубова вивіска",
  "block.minecraft.oak_leaves": "Дубове листя",
  "block.minecraft.oak_log": "Дубова колода",
  "block.minecraft.oak_planks": "Дубові дошки",
  "block.minecraft.oak_pressure_plate": "Дубова натискна плита",
  "block.minecraft.oak_sapling": "Паросток дуба",
  "block.minecraft.oak_shelf": "Дубова полиця",
  "block.minecraft.oak_sign": "Дубова табличка",
  "block.minecraft.oak_slab": "Дубова плита",
  "block.minecraft.oak_stairs": "Дубові сходи",
  "block.minecraft.oak_trapdoor": "Дубовий люк",
  "block.minecraft.oak_wall_hanging_sign": "Дубова настінна вивіска",
  "block.minecraft.oak_wall_sign": "Дубова настінна табличка",
  "block.minecraft.oak_wood": "Дубова деревина",
  "block.minecraft.observer": "Спостерігач",
  "block.minecraft.obsidian": "Обсидіан",
  "block.minecraft.ochre_froglight": "Вохристе жаб'яче світло",
  "block.minecraft.ominous_banner": "Зловісний стяг",
  "block.minecraft.open_eyeblossom": "Розкритий окоцвіт",
  "block.minecraft.orange_banner": "Помаранчевий стяг",
  "block.minecraft.orange_bed": "Помаранчеве ліжко",
  "block.minecraft.orange_candle": "Помаранчева свічка",
  "block.minecraft.orange_candle_cake": "Торт із помаранчевою свічкою",
  "block.minecraft.orange_carpet": "Помаранчевий килим",
  "block.minecraft.orange_concrete": "Помаранчевий бетон",
  "block.minecraft.orange_concrete_powder": "Помаранчевий цемент",
  "block.minecraft.orange_glazed_terracotta": "Помаранчева глазурована кераміка",
  "block.minecraft.orange_shulker_box": "Помаранчева шалкерова коробка",
  "block.minecraft.orange_stained_glass": "Помаранчеве скло",
  "block.minecraft.orange_stained_glass_pane": "Помаранчева шибка",
  "block.minecraft.orange_terracotta": "Помаранчева кераміка",
  "block.minecraft.orange_tulip": "Помаранчевий тюльпан",
  "block.minecraft.orange_wool": "Помаранчева вовна",
  "block.minecraft.oxeye_daisy": "Королиця",
  "block.minecraft.oxidized_chiseled_copper": "Окиснена різьблена мідь",
  "block.minecraft.oxidized_copper": "Окиснена мідь",
  "block.minecraft.oxidized_copper_bars": "Окиснені мідні ґрати",
  "block.minecraft.oxidized_copper_bulb": "Окиснена мідна жарівка",
  "block.minecraft.oxidized_copper_chain": "Окиснений мідний ланцюг",
  "block.minecraft.oxidized_copper_chest": "Окиснена мідна скриня",
  "block.minecraft.oxidized_copper_door": "Окиснені мідні двері",
  "block.minecraft.oxidized_copper_golem_statue": "Окиснена статуя мідного ґолема",
  "block.minecraft.oxidized_copper_grate": "Окиснена мідна решітка",
  "block.minecraft.oxidized_copper_lantern": "Окиснений мідний ліхтар",
  "block.minecraft.oxidized_copper_trapdoor": "Окиснений мідний люк",
  "block.minecraft.oxidized_cut_copper": "Окиснена тесана мідь",
  "block.minecraft.oxidized_cut_copper_slab": "Окиснена тесана мідна плита",
  "block.minecraft.oxidized_cut_copper_stairs": "Окиснені тесані мідні сходи",
  "block.minecraft.oxidized_lightning_rod": "Окиснений блискавковідвід",
  "block.minecraft.packed_ice": "Твердий лід",
  "block.minecraft.packed_mud": "Спресоване багно",
  "block.minecraft.pale_hanging_moss": "Блідий висячий мох",
  "block.minecraft.pale_moss_block": "Блідий моховий блок",
  "block.minecraft.pale_moss_carpet": "Блідий моховий покрив",
  "block.minecraft.pale_oak_button": "Блідо-дубова кнопка",
  "block.minecraft.pale_oak_door": "Блідо-дубові двері",
  "block.minecraft.pale_oak_fence": "Блідо-дубовий паркан",
  "block.minecraft.pale_oak_fence_gate": "Блідо-дубова хвіртка",
  "block.minecraft.pale_oak_hanging_sign": "Блідо-дубова вивіска",
  "block.minecraft.pale_oak_leaves": "Блідо-дубове листя",
  "block.minecraft.pale_oak_log": "Блідо-дубова колода",
  "block.minecraft.pale_oak_planks": "Блідо-дубові дошки",
  "block.minecraft.pale_oak_pressure_plate": "Блідо-дубова натискна плита",
  "block.minecraft.pale_oak_sapling": "Паросток блідого дуба",
  "block.minecraft.pale_oak_shelf": "Блідо-дубова полиця",
  "block.minecraft.pale_oak_sign": "Блідо-дубова табличка",
  "block.minecraft.pale_oak_slab": "Блідо-дубова плита",
  "block.minecraft.pale_oak_stairs": "Блідо-дубові сходи",
  "block.minecraft.pale_oak_trapdoor": "Блідо-дубовий люк",
  "block.minecraft.pale_oak_wall_hanging_sign": "Блідо-дубова настінна вивіска",
  "block.minecraft.pale_oak_wall_sign": "Блідо-дубова настінна табличка",
  "block.minecraft.pale_oak_wood": "Блідо-дубова деревина",
  "block.minecraft.pearlescent_froglight": "Перламутрове жаб'яче світло",
  "block.minecraft.peony": "Півонія",
  "block.minecraft.petrified_oak_slab": "Скам'яніла дубова плита",
  "block.minecraft.piglin_head": "Голова піґліна",
  "block.minecraft.piglin_wall_head": "Настінна голова піґліна",
  "block.minecraft.pink_banner": "Рожевий стяг",
  "block.minecraft.pink_bed": "Рожеве ліжко",
  "block.minecraft.pink_candle": "Рожева свічка",
  "block.minecraft.pink_candle_cake": "Торт із рожевою свічкою",
  "block.minecraft.pink_carpet": "Рожевий килим",
  "block.minecraft.pink_concrete": "Рожевий бетон",
  "block.minecraft.pink_concrete_powder": "Рожевий цемент",
  "block.minecraft.pink_glazed_terracotta": "Рожева глазурована кераміка",
  "block.minecraft.pink_petals": "Рожеві пелюстки",
  "block.minecraft.pink_shulker_box": "Рожева шалкерова коробка",
  "block.minecraft.pink_stained_glass": "Рожеве скло",
  "block.minecraft.pink_stained_glass_pane": "Рожева шибка",
  "block.minecraft.pink_terracotta": "Рожева кераміка",
  "block.minecraft.pink_tulip": "Рожевий тюльпан",
  "block.minecraft.pink_wool": "Рожева вовна",
  "block.minecraft.piston": "Поршень",
  "block.minecraft.piston_head": "Головка поршня",
  "block.minecraft.pitcher_crop": "Урожай глечника",
  "block.minecraft.pitcher_plant": "Глечник",
  "block.minecraft.player_head": "Голова гравця",
  "block.minecraft.player_head.named": "Голова %s",
  "block.minecraft.player_wall_head": "Настінна голова гравця",
  "block.minecraft.podzol": "Підзол",
  "block.minecraft.pointed_dripstone": "Загострений сталактит",
  "block.minecraft.polished_andesite": "Полірований андезит",
  "block.minecraft.polished_andesite_slab": "Плита з полірованого андезиту",
  "block.minecraft.polished_andesite_stairs": "Сходи з полірованого андезиту",
  "block.minecraft.polished_basalt": "Полірований базальт",
  "block.minecraft.polished_blackstone": "Полірований чорнокамінь",
  "block.minecraft.polished_blackstone_brick_slab": "Плита з полірованої чорнокам'яної цегли",
  "block.minecraft.polished_blackstone_brick_stairs": "Сходи з полірованої чорнокам'яної цегли",
  "block.minecraft.polished_blackstone_brick_wall": "Стіна з полірованої чорнокам'яної цегли",
  "block.minecraft.polished_blackstone_bricks": "Полірована чорнокам'яна цегла",
  "block.minecraft.polished_blackstone_button": "Кнопка з полірованого чорнокаменю",
  "block.minecraft.polished_blackstone_pressure_plate": "Натискна плита з полірованого чорнокаменю",
  "block.minecraft.polished_blackstone_slab": "Плита з полірованого чорнокаменю",
  "block.minecraft.polished_blackstone_stairs": "Сходи з полірованого чорнокаменю",
  "block.minecraft.polished_blackstone_wall": "Стіна з полірованого чорнокаменю",
  "block.minecraft.polished_deepslate": "Полірований глибосланець",
  "block.minecraft.polished_deepslate_slab": "Плита з полірованого глибосланцю",
  "block.minecraft.polished_deepslate_stairs": "Сходи з полірованого глибосланцю",
  "block.minecraft.polished_deepslate_wall": "Стіна з полірованого глибосланцю",
  "block.minecraft.polished_diorite": "Полірований діорит",
  "block.minecraft.polished_diorite_slab": "Плита з полірованого діориту",
  "block.minecraft.polished_diorite_stairs": "Сходи з полірованого діориту",
  "block.minecraft.polished_granite": "Полірований граніт",
  "block.minecraft.polished_granite_slab": "Плита з полірованого граніту",
  "block.minecraft.polished_granite_stairs": "Сходи з полірованого граніту",
  "block.minecraft.polished_tuff": "Полірований туф",
  "block.minecraft.polished_tuff_slab": "Плита з полірованого туфу",
  "block.minecraft.polished_tuff_stairs": "Сходи з полірованого туфу",
  "block.minecraft.polished_tuff_wall": "Стіна з полірованого туфу",
  "block.minecraft.poppy": "Мак",
  "block.minecraft.potatoes": "Картопля",
  "block.minecraft.potted_acacia_sapling": "Паросток акації в горщику",
  "block.minecraft.potted_allium": "Різанець у горщику",
  "block.minecraft.potted_azalea_bush": "Азалія в горщику",
  "block.minecraft.potted_azure_bluet": "Черемша в горщику",
  "block.minecraft.potted_bamboo": "Бамбук у горщику",
  "block.minecraft.potted_birch_sapling": "Паросток берези в горщику",
  "block.minecraft.potted_blue_orchid": "Синя орхідея в горщику",
  "block.minecraft.potted_brown_mushroom": "Коричневий гриб у горщику",
  "block.minecraft.potted_cactus": "Кактус у горщику",
  "block.minecraft.potted_cherry_sapling": "Паросток вишні в горщику",
  "block.minecraft.potted_closed_eyeblossom": "Закритий окоцвіт у горщику",
  "block.minecraft.potted_cornflower": "Волошка в горщику",
  "block.minecraft.potted_crimson_fungus": "Багряний гриб у горщику",
  "block.minecraft.potted_crimson_roots": "Багряне коріння в горщику",
  "block.minecraft.potted_dandelion": "Кульбаба в горщику",
  "block.minecraft.potted_dark_oak_sapling": "Паросток темного дуба в горщику",
  "block.minecraft.potted_dead_bush": "Мертвий кущ у горщику",
  "block.minecraft.potted_fern": "Папороть у горщику",
  "block.minecraft.potted_flowering_azalea_bush": "Квітуча азалія в горщику",
  "block.minecraft.potted_golden_dandelion": "Золота кульбаба в горщику",
  "block.minecraft.potted_jungle_sapling": "Паросток тропічного дерева в горщику",
  "block.minecraft.potted_lily_of_the_valley": "Конвалії в горщику",
  "block.minecraft.potted_mangrove_propagule": "Мангровий живець у горщику",
  "block.minecraft.potted_oak_sapling": "Паросток дуба в горщику",
  "block.minecraft.potted_open_eyeblossom": "Розкритий окоцвіт у горщику",
  "block.minecraft.potted_orange_tulip": "Помаранчевий тюльпан у горщику",
  "block.minecraft.potted_oxeye_daisy": "Королиця в горщику",
  "block.minecraft.potted_pale_oak_sapling": "Паросток блідого дуба в горщику",
  "block.minecraft.potted_pink_tulip": "Рожевий тюльпан у горщику",
  "block.minecraft.potted_poppy": "Мак у горщику",
  "block.minecraft.potted_red_mushroom": "Червоний гриб у горщику",
  "block.minecraft.potted_red_tulip": "Червоний тюльпан у горщику",
  "block.minecraft.potted_spruce_sapling": "Паросток смереки в горщику",
  "block.minecraft.potted_torchflower": "Смолоскипник у горщику",
  "block.minecraft.potted_warped_fungus": "Химерний гриб у горщику",
  "block.minecraft.potted_warped_roots": "Химерне коріння в горщику",
  "block.minecraft.potted_white_tulip": "Білий тюльпан у горщику",
  "block.minecraft.potted_wither_rose": "Троянда візера в горщику",
  "block.minecraft.powder_snow": "Сипкий сніг",
  "block.minecraft.powder_snow_cauldron": "Казан із сипким снігом",
  "block.minecraft.powered_rail": "Електризовані рейки",
  "block.minecraft.prismarine": "Призмарин",
  "block.minecraft.prismarine_brick_slab": "Плита з призмаринової цегли",
  "block.minecraft.prismarine_brick_stairs": "Сходи з призмаринової цегли",
  "block.minecraft.prismarine_bricks": "Призмаринова цегла",
  "block.minecraft.prismarine_slab": "Призмаринова плита",
  "block.minecraft.prismarine_stairs": "Призмаринові сходи",
  "block.minecraft.prismarine_wall": "Призмаринова стіна",
  "block.minecraft.pumpkin": "Гарбуз",
  "block.minecraft.pumpkin_stem": "Стебло гарбуза",
  "block.minecraft.purple_banner": "Фіолетовий стяг",
  "block.minecraft.purple_bed": "Фіолетове ліжко",
  "block.minecraft.purple_candle": "Фіолетова свічка",
  "block.minecraft.purple_candle_cake": "Торт із фіолетовою свічкою",
  "block.minecraft.purple_carpet": "Фіолетовий килим",
  "block.minecraft.purple_concrete": "Фіолетовий бетон",
  "block.minecraft.purple_concrete_powder": "Фіолетовий цемент",
  "block.minecraft.purple_glazed_terracotta": "Фіолетова глазурована кераміка",
  "block.minecraft.purple_shulker_box": "Фіолетова шалкерова коробка",
  "block.minecraft.purple_stained_glass": "Фіолетове скло",
  "block.minecraft.purple_stained_glass_pane": "Фіолетова шибка",
  "block.minecraft.purple_terracotta": "Фіолетова кераміка",
  "block.minecraft.purple_wool": "Фіолетова вовна",
  "block.minecraft.purpur_block": "Блок пурпуру",
  "block.minecraft.purpur_pillar": "Колона з пурпуру",
  "block.minecraft.purpur_slab": "Плита з пурпуру",
  "block.minecraft.purpur_stairs": "Сходи з пурпуру",
  "block.minecraft.quartz_block": "Блок кварцу",
  "block.minecraft.quartz_bricks": "Кварцова цегла",
  "block.minecraft.quartz_pillar": "Кварцова колона",
  "block.minecraft.quartz_slab": "Кварцова плита",
  "block.minecraft.quartz_stairs": "Кварцові сходи",
  "block.minecraft.rail": "Рейки",
  "block.minecraft.raw_copper_block": "Блок необробленої міді",
  "block.minecraft.raw_gold_block": "Блок необробленого золота",
  "block.minecraft.raw_iron_block": "Блок необробленого заліза",
  "block.minecraft.red_banner": "Червоний стяг",
  "block.minecraft.red_bed": "Червоне ліжко",
  "block.minecraft.red_candle": "Червона свічка",
  "block.minecraft.red_candle_cake": "Торт із червоною свічкою",
  "block.minecraft.red_carpet": "Червоний килим",
  "block.minecraft.red_concrete": "Червоний бетон",
  "block.minecraft.red_concrete_powder": "Червоний цемент",
  "block.minecraft.red_glazed_terracotta": "Червона глазурована кераміка",
  "block.minecraft.red_mushroom": "Червоний гриб",
  "block.minecraft.red_mushroom_block": "Блок червоного гриба",
  "block.minecraft.red_nether_brick_slab": "Плита з червоної незерської цегли",
  "block.minecraft.red_nether_brick_stairs": "Сходи з червоної незерської цегли",
  "block.minecraft.red_nether_brick_wall": "Стіна з червоної незерської цегли",
  "block.minecraft.red_nether_bricks": "Червона незерська цегла",
  "block.minecraft.red_sand": "Червоний пісок",
  "block.minecraft.red_sandstone": "Червоний пісковик",
  "block.minecraft.red_sandstone_slab": "Плита з червоного пісковику",
  "block.minecraft.red_sandstone_stairs": "Сходи з червоного пісковику",
  "block.minecraft.red_sandstone_wall": "Стіна з червоного пісковику",
  "block.minecraft.red_shulker_box": "Червона шалкерова коробка",
  "block.minecraft.red_stained_glass": "Червоне скло",
  "block.minecraft.red_stained_glass_pane": "Червона шибка",
  "block.minecraft.red_terracotta": "Червона кераміка",
  "block.minecraft.red_tulip": "Червоний тюльпан",
  "block.minecraft.red_wool": "Червона вовна",
  "block.minecraft.redstone_block": "Блок редстоуну",
  "block.minecraft.redstone_lamp": "Редстоунова лампа",
  "block.minecraft.redstone_ore": "Редстоунова руда",
  "block.minecraft.redstone_torch": "Редстоуновий смолоскип",
  "block.minecraft.redstone_wall_torch": "Редстоуновий настінний смолоскип",
  "block.minecraft.redstone_wire": "Редстоуновий провід",
  "block.minecraft.reinforced_deepslate": "Посилений глибосланець",
  "block.minecraft.repeater": "Редстоуновий повторювач",
  "block.minecraft.repeating_command_block": "Повторювальний командний блок",
  "block.minecraft.resin_block": "Блок смоли",
  "block.minecraft.resin_brick_slab": "Плита зі смоляної цегли",
  "block.minecraft.resin_brick_stairs": "Сходи зі смоляної цегли",
  "block.minecraft.resin_brick_wall": "Стіна зі смоляної цегли",
  "block.minecraft.resin_bricks": "Смоляна цегла",
  "block.minecraft.resin_clump": "Згусток смоли",
  "block.minecraft.respawn_anchor": "Якір відродження",
  "block.minecraft.rooted_dirt": "Кореневий ґрунт",
  "block.minecraft.rose_bush": "Трояндовий кущ",
  "block.minecraft.sand": "Пісок",
  "block.minecraft.sandstone": "Пісковик",
  "block.minecraft.sandstone_slab": "Пісковикова плита",
  "block.minecraft.sandstone_stairs": "Пісковикові сходи",
  "block.minecraft.sandstone_wall": "Пісковикова стіна",
  "block.minecraft.scaffolding": "Риштування",
  "block.minecraft.sculk": "Скалк",
  "block.minecraft.sculk_catalyst": "Скалковий каталізатор",
  "block.minecraft.sculk_sensor": "Скалковий сенсор",
  "block.minecraft.sculk_shrieker": "Скалковий крикун",
  "block.minecraft.sculk_vein": "Скалкова жила",
  "block.minecraft.sea_lantern": "Морський ліхтар",
  "block.minecraft.sea_pickle": "Морський огірок",
  "block.minecraft.seagrass": "Морська трава",
  "block.minecraft.set_spawn": "Точку відродження встановлено",
  "block.minecraft.short_dry_grass": "Низька суха трава",
  "block.minecraft.short_grass": "Низька трава",
  "block.minecraft.shroomlight": "Світлогриб",
  "block.minecraft.shulker_box": "Шалкерова коробка",
  "block.minecraft.skeleton_skull": "Череп скелета",
  "block.minecraft.skeleton_wall_skull": "Настінний череп скелета",
  "block.minecraft.slime_block": "Слизовий блок",
  "block.minecraft.small_amethyst_bud": "Малий зародок аметиста",
  "block.minecraft.small_dripleaf": "Малий краплелист",
  "block.minecraft.smithing_table": "Ковальський стіл",
  "block.minecraft.smoker": "Коптильня",
  "block.minecraft.smooth_basalt": "Гладкий базальт",
  "block.minecraft.smooth_quartz": "Гладкий кварцовий блок",
  "block.minecraft.smooth_quartz_slab": "Плита з гладкого кварцу",
  "block.minecraft.smooth_quartz_stairs": "Сходи з гладкого кварцу",
  "block.minecraft.smooth_red_sandstone": "Гладкий червоний пісковик",
  "block.minecraft.smooth_red_sandstone_slab": "Плита з гладкого червоного пісковику",
  "block.minecraft.smooth_red_sandstone_stairs": "Сходи з гладкого червоного пісковику",
  "block.minecraft.smooth_sandstone": "Гладкий пісковик",
  "block.minecraft.smooth_sandstone_slab": "Плита з гладкого пісковику",
  "block.minecraft.smooth_sandstone_stairs": "Сходи з гладкого пісковику",
  "block.minecraft.smooth_stone": "Гладкий камінь",
  "block.minecraft.smooth_stone_slab": "Плита з гладкого каменю",
  "block.minecraft.sniffer_egg": "Яйце нюхача",
  "block.minecraft.snow": "Сніг",
  "block.minecraft.snow_block": "Сніговий блок",
  "block.minecraft.soul_campfire": "Багаття душ",
  "block.minecraft.soul_fire": "Вогонь душ",
  "block.minecraft.soul_lantern": "Ліхтар душ",
  "block.minecraft.soul_sand": "Пісок душ",
  "block.minecraft.soul_soil": "Ґрунт душ",
  "block.minecraft.soul_torch": "Смолоскип душ",
  "block.minecraft.soul_wall_torch": "Настінний смолоскип душ",
  "block.minecraft.spawn.not_valid": "У вас або немає ліжка або зарядженого якоря відродження, або вони недоступні",
  "block.minecraft.spawner": "Породжувач монстрів",
  "block.minecraft.spawner.desc1": "Взаємодія з яйцем виклику:",
  "block.minecraft.spawner.desc2": "Установлює тип моба",
  "block.minecraft.sponge": "Губка",
  "block.minecraft.spore_blossom": "Спороцвіт",
  "block.minecraft.spruce_button": "Смерекова кнопка",
  "block.minecraft.spruce_door": "Смерекові двері",
  "block.minecraft.spruce_fence": "Смерековий паркан",
  "block.minecraft.spruce_fence_gate": "Смерекова хвіртка",
  "block.minecraft.spruce_hanging_sign": "Смерекова вивіска",
  "block.minecraft.spruce_leaves": "Смерекове листя",
  "block.minecraft.spruce_log": "Смерекова колода",
  "block.minecraft.spruce_planks": "Смерекові дошки",
  "block.minecraft.spruce_pressure_plate": "Смерекова натискна плита",
  "block.minecraft.spruce_sapling": "Паросток смереки",
  "block.minecraft.spruce_shelf": "Смерекова полиця",
  "block.minecraft.spruce_sign": "Смерекова табличка",
  "block.minecraft.spruce_slab": "Смерекова плита",
  "block.minecraft.spruce_stairs": "Смерекові сходи",
  "block.minecraft.spruce_trapdoor": "Смерековий люк",
  "block.minecraft.spruce_wall_hanging_sign": "Смерекова настінна вивіска",
  "block.minecraft.spruce_wall_sign": "Смерекова настінна табличка",
  "block.minecraft.spruce_wood": "Смерекова деревина",
  "block.minecraft.sticky_piston": "Липкий поршень",
  "block.minecraft.stone": "Камінь",
  "block.minecraft.stone_brick_slab": "Плита з кам'яної цегли",
  "block.minecraft.stone_brick_stairs": "Сходи з кам'яної цегли",
  "block.minecraft.stone_brick_wall": "Стіна з кам'яної цегли",
  "block.minecraft.stone_bricks": "Кам'яна цегла",
  "block.minecraft.stone_button": "Кам'яна кнопка",
  "block.minecraft.stone_pressure_plate": "Кам'яна натискна плита",
  "block.minecraft.stone_slab": "Кам'яна плита",
  "block.minecraft.stone_stairs": "Кам'яні сходи",
  "block.minecraft.stonecutter": "Каменеріз",
  "block.minecraft.stripped_acacia_log": "Обтесана акацієва колода",
  "block.minecraft.stripped_acacia_wood": "Обтесана акацієва деревина",
  "block.minecraft.stripped_bamboo_block": "Блок обтесаного бамбука",
  "block.minecraft.stripped_birch_log": "Обтесана березова колода",
  "block.minecraft.stripped_birch_wood": "Обтесана березова деревина",
  "block.minecraft.stripped_cherry_log": "Обтесана вишнева колода",
  "block.minecraft.stripped_cherry_wood": "Обтесана вишнева деревина",
  "block.minecraft.stripped_crimson_hyphae": "Обтесані багряні гіфи",
  "block.minecraft.stripped_crimson_stem": "Обтесана багряна ніжка",
  "block.minecraft.stripped_dark_oak_log": "Обтесана темно-дубова колода",
  "block.minecraft.stripped_dark_oak_wood": "Обтесана темно-дубова деревина",
  "block.minecraft.stripped_jungle_log": "Обтесана тропічна колода",
  "block.minecraft.stripped_jungle_wood": "Обтесана тропічна деревина",
  "block.minecraft.stripped_mangrove_log": "Обтесана мангрова колода",
  "block.minecraft.stripped_mangrove_wood": "Обтесана мангрова деревина",
  "block.minecraft.stripped_oak_log": "Обтесана дубова колода",
  "block.minecraft.stripped_oak_wood": "Обтесана дубова деревина",
  "block.minecraft.stripped_pale_oak_log": "Обтесана блідо-дубова колода",
  "block.minecraft.stripped_pale_oak_wood": "Обтесана блідо-дубова деревина",
  "block.minecraft.stripped_spruce_log": "Обтесана смерекова колода",
  "block.minecraft.stripped_spruce_wood": "Обтесана смерекова деревина",
  "block.minecraft.stripped_warped_hyphae": "Обтесані химерні гіфи",
  "block.minecraft.stripped_warped_stem": "Обтесана химерна ніжка",
  "block.minecraft.structure_block": "Структурний блок",
  "block.minecraft.structure_void": "Структурна порожнеча",
  "block.minecraft.sugar_cane": "Цукрова тростина",
  "block.minecraft.sunflower": "Соняшник",
  "block.minecraft.suspicious_gravel": "Підозрілий гравій",
  "block.minecraft.suspicious_sand": "Підозрілий пісок",
  "block.minecraft.sweet_berry_bush": "Кущ солодких ягід",
  "block.minecraft.tall_dry_grass": "Висока суха трава",
  "block.minecraft.tall_grass": "Висока трава",
  "block.minecraft.tall_seagrass": "Висока морська трава",
  "block.minecraft.target": "Мішень",
  "block.minecraft.terracotta": "Кераміка",
  "block.minecraft.test_block": "Тестовий блок",
  "block.minecraft.test_instance_block": "Блок тестового примірника",
  "block.minecraft.tinted_glass": "Тоноване скло",
  "block.minecraft.tnt": "Динаміт",
  "block.minecraft.tnt.disabled": "Вибухи динаміту вимкнені",
  "block.minecraft.torch": "Смолоскип",
  "block.minecraft.torchflower": "Смолоскипник",
  "block.minecraft.torchflower_crop": "Урожай смолоскипника",
  "block.minecraft.trapped_chest": "Скриня-пастка",
  "block.minecraft.trial_spawner": "Породжувач випробувань",
  "block.minecraft.tripwire": "Розтяжка",
  "block.minecraft.tripwire_hook": "Гак для розтяжки",
  "block.minecraft.tube_coral": "Трубчастий корал",
  "block.minecraft.tube_coral_block": "Блок трубчастого корала",
  "block.minecraft.tube_coral_fan": "Віяло з трубчастих коралів",
  "block.minecraft.tube_coral_wall_fan": "Настінне віяло з трубчастих коралів",
  "block.minecraft.tuff": "Туф",
  "block.minecraft.tuff_brick_slab": "Плита з туфової цегли",
  "block.minecraft.tuff_brick_stairs": "Сходи з туфової цегли",
  "block.minecraft.tuff_brick_wall": "Стіна з туфової цегли",
  "block.minecraft.tuff_bricks": "Туфова цегла",
  "block.minecraft.tuff_slab": "Туфова плита",
  "block.minecraft.tuff_stairs": "Туфові сходи",
  "block.minecraft.tuff_wall": "Туфова стіна",
  "block.minecraft.turtle_egg": "Яйце черепахи",
  "block.minecraft.twisting_vines": "Кручені лози",
  "block.minecraft.twisting_vines_plant": "Стебло кручених ліз",
  "block.minecraft.vault": "Сховище",
  "block.minecraft.verdant_froglight": "Зелене жаб'яче світло",
  "block.minecraft.vine": "Лози",
  "block.minecraft.void_air": "Вакуум",
  "block.minecraft.wall_torch": "Настінний смолоскип",
  "block.minecraft.warped_button": "Химерна кнопка",
  "block.minecraft.warped_door": "Химерні двері",
  "block.minecraft.warped_fence": "Химерний паркан",
  "block.minecraft.warped_fence_gate": "Химерна хвіртка",
  "block.minecraft.warped_fungus": "Химерний гриб",
  "block.minecraft.warped_hanging_sign": "Химерна вивіска",
  "block.minecraft.warped_hyphae": "Химерні гіфи",
  "block.minecraft.warped_nylium": "Химерний нілій",
  "block.minecraft.warped_planks": "Химерні дошки",
  "block.minecraft.warped_pressure_plate": "Химерна натискна плита",
  "block.minecraft.warped_roots": "Химерне коріння",
  "block.minecraft.warped_shelf": "Химерна полиця",
  "block.minecraft.warped_sign": "Химерна табличка",
  "block.minecraft.warped_slab": "Химерна плита",
  "block.minecraft.warped_stairs": "Химерні сходи",
  "block.minecraft.warped_stem": "Химерна ніжка",
  "block.minecraft.warped_trapdoor": "Химерний люк",
  "block.minecraft.warped_wall_hanging_sign": "Химерна настінна вивіска",
  "block.minecraft.warped_wall_sign": "Химерна настінна табличка",
  "block.minecraft.warped_wart_block": "Блок химерного наросту",
  "block.minecraft.water": "Вода",
  "block.minecraft.water_cauldron": "Казан із водою",
  "block.minecraft.waxed_chiseled_copper": "Вощена різьблена мідь",
  "block.minecraft.waxed_copper_bars": "Вощені мідні ґрати",
  "block.minecraft.waxed_copper_block": "Вощений блок міді",
  "block.minecraft.waxed_copper_bulb": "Вощена мідна жарівка",
  "block.minecraft.waxed_copper_chain": "Вощений мідний ланцюг",
  "block.minecraft.waxed_copper_chest": "Вощена мідна скриня",
  "block.minecraft.waxed_copper_door": "Вощені мідні двері",
  "block.minecraft.waxed_copper_golem_statue": "Вощена статуя мідного ґолема",
  "block.minecraft.waxed_copper_grate": "Вощена мідна решітка",
  "block.minecraft.waxed_copper_lantern": "Вощений мідний ліхтар",
  "block.minecraft.waxed_copper_trapdoor": "Вощений мідний люк",
  "block.minecraft.waxed_cut_copper": "Вощена тесана мідь",
  "block.minecraft.waxed_cut_copper_slab": "Вощена тесана мідна плита",
  "block.minecraft.waxed_cut_copper_stairs": "Вощені тесані мідні сходи",
  "block.minecraft.waxed_exposed_chiseled_copper": "Вощена наражена різьблена мідь",
  "block.minecraft.waxed_exposed_copper": "Вощена наражена мідь",
  "block.minecraft.waxed_exposed_copper_bars": "Вощені наражені мідні ґрати",
  "block.minecraft.waxed_exposed_copper_bulb": "Вощена наражена мідна жарівка",
  "block.minecraft.waxed_exposed_copper_chain": "Вощений наражений мідний ланцюг",
  "block.minecraft.waxed_exposed_copper_chest": "Вощена наражена мідна скриня",
  "block.minecraft.waxed_exposed_copper_door": "Вощені наражені мідні двері",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Вощена наражена статуя мідного ґолема",
  "block.minecraft.waxed_exposed_copper_grate": "Вощена наражена мідна решітка",
  "block.minecraft.waxed_exposed_copper_lantern": "Вощений наражений мідний ліхтар",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Вощений наражений мідний люк",
  "block.minecraft.waxed_exposed_cut_copper": "Вощена наражена тесана мідь",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Вощена наражена тесана мідна плита",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Вощені наражені тесані мідні сходи",
  "block.minecraft.waxed_exposed_lightning_rod": "Вощений наражений блискавковідвід",
  "block.minecraft.waxed_lightning_rod": "Вощений блискавковідвід",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Вощена окиснена різьблена мідь",
  "block.minecraft.waxed_oxidized_copper": "Вощена окиснена мідь",
  "block.minecraft.waxed_oxidized_copper_bars": "Вощені окиснені мідні ґрати",
  "block.minecraft.waxed_oxidized_copper_bulb": "Вощена окиснена мідна жарівка",
  "block.minecraft.waxed_oxidized_copper_chain": "Вощений окиснений мідний ланцюг",
  "block.minecraft.waxed_oxidized_copper_chest": "Вощена окиснена мідна скриня",
  "block.minecraft.waxed_oxidized_copper_door": "Вощені окиснені мідні двері",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Вощена окиснена статуя мідного ґолема",
  "block.minecraft.waxed_oxidized_copper_grate": "Вощена окиснена мідна решітка",
  "block.minecraft.waxed_oxidized_copper_lantern": "Вощений окиснений мідний ліхтар",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Вощений окиснений мідний люк",
  "block.minecraft.waxed_oxidized_cut_copper": "Вощена окиснена тесана мідь",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Вощена окиснена тесана мідна плита",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Вощені окиснені тесані мідні сходи",
  "block.minecraft.waxed_oxidized_lightning_rod": "Вощений окиснений блискавковідвід",
  "block.minecraft.waxed_weathered_chiseled_copper": "Вощена вивітрена різьблена мідь",
  "block.minecraft.waxed_weathered_copper": "Вощена вивітрена мідь",
  "block.minecraft.waxed_weathered_copper_bars": "Вощені вивітрені мідні ґрати",
  "block.minecraft.waxed_weathered_copper_bulb": "Вощена вивітрена мідна жарівка",
  "block.minecraft.waxed_weathered_copper_chain": "Вощений вивітрений мідний ланцюг",
  "block.minecraft.waxed_weathered_copper_chest": "Вощена вивітрена мідна скриня",
  "block.minecraft.waxed_weathered_copper_door": "Вощені вивітрені мідні двері",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Вощена вивітрена статуя мідного ґолема",
  "block.minecraft.waxed_weathered_copper_grate": "Вощена вивітрена мідна решітка",
  "block.minecraft.waxed_weathered_copper_lantern": "Вощений вивітрений мідний ліхтар",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Вощений вивітрений мідний люк",
  "block.minecraft.waxed_weathered_cut_copper": "Вощена вивітрена тесана мідь",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Вощена вивітрена тесана мідна плита",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Вощені вивітрені тесані мідні сходи",
  "block.minecraft.waxed_weathered_lightning_rod": "Вощений вивітрений блискавковідвід",
  "block.minecraft.weathered_chiseled_copper": "Вивітрена різьблена мідь",
  "block.minecraft.weathered_copper": "Вивітрена мідь",
  "block.minecraft.weathered_copper_bars": "Вивітрені мідні ґрати",
  "block.minecraft.weathered_copper_bulb": "Вивітрена мідна жарівка",
  "block.minecraft.weathered_copper_chain": "Вивітрений мідний ланцюг",
  "block.minecraft.weathered_copper_chest": "Вивітрена мідна скриня",
  "block.minecraft.weathered_copper_door": "Вивітрені мідні двері",
  "block.minecraft.weathered_copper_golem_statue": "Вивітрена статуя мідного ґолема",
  "block.minecraft.weathered_copper_grate": "Вивітрена мідна решітка",
  "block.minecraft.weathered_copper_lantern": "Вивітрений мідний ліхтар",
  "block.minecraft.weathered_copper_trapdoor": "Вивітрений мідний люк",
  "block.minecraft.weathered_cut_copper": "Вивітрена тесана мідь",
  "block.minecraft.weathered_cut_copper_slab": "Вивітрена тесана мідна плита",
  "block.minecraft.weathered_cut_copper_stairs": "Вивітрені тесані мідні сходи",
  "block.minecraft.weathered_lightning_rod": "Вивітрений блискавковідвід",
  "block.minecraft.weeping_vines": "Плакучі лози",
  "block.minecraft.weeping_vines_plant": "Стебло плакучих ліз",
  "block.minecraft.wet_sponge": "Мокра губка",
  "block.minecraft.wheat": "Урожай пшениці",
  "block.minecraft.white_banner": "Білий стяг",
  "block.minecraft.white_bed": "Біле ліжко",
  "block.minecraft.white_candle": "Біла свічка",
  "block.minecraft.white_candle_cake": "Торт із білою свічкою",
  "block.minecraft.white_carpet": "Білий килим",
  "block.minecraft.white_concrete": "Білий бетон",
  "block.minecraft.white_concrete_powder": "Білий цемент",
  "block.minecraft.white_glazed_terracotta": "Біла глазурована кераміка",
  "block.minecraft.white_shulker_box": "Біла шалкерова коробка",
  "block.minecraft.white_stained_glass": "Біле скло",
  "block.minecraft.white_stained_glass_pane": "Біла шибка",
  "block.minecraft.white_terracotta": "Біла кераміка",
  "block.minecraft.white_tulip": "Білий тюльпан",
  "block.minecraft.white_wool": "Біла вовна",
  "block.minecraft.wildflowers": "Польові квіти",
  "block.minecraft.wither_rose": "Троянда візера",
  "block.minecraft.wither_skeleton_skull": "Череп візера-скелета",
  "block.minecraft.wither_skeleton_wall_skull": "Настінний череп візера-скелета",
  "block.minecraft.yellow_banner": "Жовтий стяг",
  "block.minecraft.yellow_bed": "Жовте ліжко",
  "block.minecraft.yellow_candle": "Жовта свічка",
  "block.minecraft.yellow_candle_cake": "Торт із жовтою свічкою",
  "block.minecraft.yellow_carpet": "Жовтий килим",
  "block.minecraft.yellow_concrete": "Жовтий бетон",
  "block.minecraft.yellow_concrete_powder": "Жовтий цемент",
  "block.minecraft.yellow_glazed_terracotta": "Жовта глазурована кераміка",
  "block.minecraft.yellow_shulker_box": "Жовта шалкерова коробка",
  "block.minecraft.yellow_stained_glass": "Жовте скло",
  "block.minecraft.yellow_stained_glass_pane": "Жовта шибка",
  "block.minecraft.yellow_terracotta": "Жовта кераміка",
  "block.minecraft.yellow_wool": "Жовта вовна",
  "block.minecraft.zombie_head": "Голова зомбі",
  "block.minecraft.zombie_wall_head": "Настінна голова зомбі",
  "item.minecraft.acacia_boat": "Акацієвий човен",
  "item.minecraft.acacia_chest_boat": "Акацієвий човен зі скринею",
  "item.minecraft.allay_spawn_egg": "Яйце виклику збирика",
  "item.minecraft.amethyst_shard": "Аметистовий уламок",
  "item.minecraft.angler_pottery_shard": "Уламок горщика «Рибалка»",
  "item.minecraft.angler_pottery_sherd": "Гончарний черепок «Рибалка»",
  "item.minecraft.apple": "Яблуко",
  "item.minecraft.archer_pottery_shard": "Уламок горщика «Лучник»",
  "item.minecraft.archer_pottery_sherd": "Гончарний черепок «Лучник»",
  "item.minecraft.armadillo_scute": "Щиток броненосця",
  "item.minecraft.armadillo_spawn_egg": "Яйце виклику броненосця",
  "item.minecraft.armor_stand": "Стійка для обладунків",
  "item.minecraft.arms_up_pottery_shard": "Уламок горщика «Руки догори»",
  "item.minecraft.arms_up_pottery_sherd": "Гончарний черепок «Руки догори»",
  "item.minecraft.arrow": "Стріла",
  "item.minecraft.axolotl_bucket": "Відро з аксолотлем",
  "item.minecraft.axolotl_spawn_egg": "Яйце виклику аксолотля",
  "item.minecraft.baked_potato": "Запечена картопля",
  "item.minecraft.bamboo_chest_raft": "Бамбуковий пліт зі скринею",
  "item.minecraft.bamboo_raft": "Бамбуковий пліт",
  "item.minecraft.bat_spawn_egg": "Яйце виклику кажана",
  "item.minecraft.bee_spawn_egg": "Яйце виклику бджоли",
  "item.minecraft.beef": "Сира яловичина",
  "item.minecraft.beetroot": "Буряк",
  "item.minecraft.beetroot_seeds": "Насіння буряка",
  "item.minecraft.beetroot_soup": "Борщ",
  "item.minecraft.birch_boat": "Березовий човен",
  "item.minecraft.birch_chest_boat": "Березовий човен зі скринею",
  "item.minecraft.black_bundle": "Чорний мішечок",
  "item.minecraft.black_dye": "Чорний барвник",
  "item.minecraft.black_harness": "Чорна упряж",
  "item.minecraft.blade_pottery_shard": "Уламок горщика «Лезо»",
  "item.minecraft.blade_pottery_sherd": "Гончарний черепок «Лезо»",
  "item.minecraft.blaze_powder": "Порох пломеня",
  "item.minecraft.blaze_rod": "Стрижень пломеня",
  "item.minecraft.blaze_spawn_egg": "Яйце виклику пломеня",
  "item.minecraft.blue_bundle": "Синій мішечок",
  "item.minecraft.blue_dye": "Синій барвник",
  "item.minecraft.blue_egg": "Блакитне яйце",
  "item.minecraft.blue_harness": "Синя упряж",
  "item.minecraft.bogged_spawn_egg": "Яйце виклику болотяника",
  "item.minecraft.bolt_armor_trim_smithing_template": "Ковальський шаблон",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Орнамент обладунків «Блискавка»",
  "item.minecraft.bone": "Кістка",
  "item.minecraft.bone_meal": "Кісткове борошно",
  "item.minecraft.book": "Книга",
  "item.minecraft.bordure_indented_banner_pattern": "Візерунок стяга «Зубчата рамка»",
  "item.minecraft.bow": "Лук",
  "item.minecraft.bowl": "Миска",
  "item.minecraft.bread": "Хліб",
  "item.minecraft.breeze_rod": "Стрижень вітреня",
  "item.minecraft.breeze_spawn_egg": "Яйце виклику вітреня",
  "item.minecraft.brewer_pottery_shard": "Уламок горщика «Варильник»",
  "item.minecraft.brewer_pottery_sherd": "Гончарний черепок «Варильник»",
  "item.minecraft.brewing_stand": "Варильна стійка",
  "item.minecraft.brick": "Цеглина",
  "item.minecraft.brown_bundle": "Коричневий мішечок",
  "item.minecraft.brown_dye": "Коричневий барвник",
  "item.minecraft.brown_egg": "Коричневе яйце",
  "item.minecraft.brown_harness": "Коричнева упряж",
  "item.minecraft.brush": "Щітка",
  "item.minecraft.bucket": "Відро",
  "item.minecraft.bundle": "Мішечок",
  "item.minecraft.bundle.empty": "Порожній",
  "item.minecraft.bundle.empty.description": "Може містити мішаний стіс предметів",
  "item.minecraft.bundle.full": "Повний",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Уламок горщика «Полум'я»",
  "item.minecraft.burn_pottery_sherd": "Гончарний черепок «Полум'я»",
  "item.minecraft.camel_husk_spawn_egg": "Яйце виклику верблюда-висушня",
  "item.minecraft.camel_spawn_egg": "Яйце виклику верблюда",
  "item.minecraft.carrot": "Морква",
  "item.minecraft.carrot_on_a_stick": "Морква на паличці",
  "item.minecraft.cat_spawn_egg": "Яйце виклику кота",
  "item.minecraft.cauldron": "Казан",
  "item.minecraft.cave_spider_spawn_egg": "Яйце виклику печерного павука",
  "item.minecraft.chainmail_boots": "Кольчужні чоботи",
  "item.minecraft.chainmail_chestplate": "Кольчужний нагрудник",
  "item.minecraft.chainmail_helmet": "Кольчужний шолом",
  "item.minecraft.chainmail_leggings": "Кольчужні наголінники",
  "item.minecraft.charcoal": "Деревне вугілля",
  "item.minecraft.cherry_boat": "Вишневий човен",
  "item.minecraft.cherry_chest_boat": "Вишневий човен зі скринею",
  "item.minecraft.chest_minecart": "Вагонетка зі скринею",
  "item.minecraft.chicken": "Сира курятина",
  "item.minecraft.chicken_spawn_egg": "Яйце виклику курки",
  "item.minecraft.chorus_fruit": "Фрукт хорусу",
  "item.minecraft.clay_ball": "Глиняна кулька",
  "item.minecraft.clock": "Годинник",
  "item.minecraft.coal": "Вугілля",
  "item.minecraft.coast_armor_trim_smithing_template": "Ковальський шаблон",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Орнамент обладунків «Берег»",
  "item.minecraft.cocoa_beans": "Какао-боби",
  "item.minecraft.cod": "Сира тріска",
  "item.minecraft.cod_bucket": "Відро з тріскою",
  "item.minecraft.cod_spawn_egg": "Яйце виклику тріски",
  "item.minecraft.command_block_minecart": "Вагонетка з командним блоком",
  "item.minecraft.compass": "Компас",
  "item.minecraft.cooked_beef": "Стейк",
  "item.minecraft.cooked_chicken": "Смажена курятина",
  "item.minecraft.cooked_cod": "Смажена тріска",
  "item.minecraft.cooked_mutton": "Смажена баранина",
  "item.minecraft.cooked_porkchop": "Смажена свинина",
  "item.minecraft.cooked_rabbit": "Смажена кролятина",
  "item.minecraft.cooked_salmon": "Смажений лосось",
  "item.minecraft.cookie": "Печиво",
  "item.minecraft.copper_axe": "Мідна сокира",
  "item.minecraft.copper_boots": "Мідні чоботи",
  "item.minecraft.copper_chestplate": "Мідний нагрудник",
  "item.minecraft.copper_golem_spawn_egg": "Яйце виклику мідного ґолема",
  "item.minecraft.copper_helmet": "Мідний шолом",
  "item.minecraft.copper_hoe": "Мідна мотика",
  "item.minecraft.copper_horse_armor": "Мідні кінські обладунки",
  "item.minecraft.copper_ingot": "Мідний злиток",
  "item.minecraft.copper_leggings": "Мідні наголінники",
  "item.minecraft.copper_nautilus_armor": "Мідні обладунки навтилуса",
  "item.minecraft.copper_nugget": "Мідний самородок",
  "item.minecraft.copper_pickaxe": "Мідне кайло",
  "item.minecraft.copper_shovel": "Мідна лопата",
  "item.minecraft.copper_spear": "Мідний спис",
  "item.minecraft.copper_sword": "Мідний меч",
  "item.minecraft.cow_spawn_egg": "Яйце виклику корови",
  "item.minecraft.creaking_spawn_egg": "Яйце виклику скрипня",
  "item.minecraft.creeper_banner_pattern": "Візерунок стяга",
  "item.minecraft.creeper_banner_pattern.desc": "Емблема кріпера",
  "item.minecraft.creeper_banner_pattern.new": "Візерунок стяга «Емблема кріпера»",
  "item.minecraft.creeper_spawn_egg": "Яйце виклику кріпера",
  "item.minecraft.crossbow": "Арбалет",
  "item.minecraft.crossbow.projectile": "Снаряд:",
  "item.minecraft.crossbow.projectile.multiple": "Снаряд: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Снаряд: %s",
  "item.minecraft.cyan_bundle": "Бірюзовий мішечок",
  "item.minecraft.cyan_dye": "Бірюзовий барвник",
  "item.minecraft.cyan_harness": "Бірюзова упряж",
  "item.minecraft.danger_pottery_shard": "Уламок горщика «Небезпека»",
  "item.minecraft.danger_pottery_sherd": "Гончарний черепок «Небезпека»",
  "item.minecraft.dark_oak_boat": "Темно-дубовий човен",
  "item.minecraft.dark_oak_chest_boat": "Темно-дубовий човен зі скринею",
  "item.minecraft.debug_stick": "Палиця налагодження",
  "item.minecraft.debug_stick.empty": "%s не має властивостей",
  "item.minecraft.debug_stick.select": "обрано «%s» (%s)",
  "item.minecraft.debug_stick.update": "«%s»: %s",
  "item.minecraft.diamond": "Діамант",
  "item.minecraft.diamond_axe": "Діамантова сокира",
  "item.minecraft.diamond_boots": "Діамантові чоботи",
  "item.minecraft.diamond_chestplate": "Діамантовий нагрудник",
  "item.minecraft.diamond_helmet": "Діамантовий шолом",
  "item.minecraft.diamond_hoe": "Діамантова мотика",
  "item.minecraft.diamond_horse_armor": "Діамантові кінські обладунки",
  "item.minecraft.diamond_leggings": "Діамантові наголінники",
  "item.minecraft.diamond_nautilus_armor": "Діамантові обладунки навтилуса",
  "item.minecraft.diamond_pickaxe": "Діамантове кайло",
  "item.minecraft.diamond_shovel": "Діамантова лопата",
  "item.minecraft.diamond_spear": "Діамантовий спис",
  "item.minecraft.diamond_sword": "Діамантовий меч",
  "item.minecraft.disc_fragment_5": "Фрагмент платівки",
  "item.minecraft.disc_fragment_5.desc": "Платівка — 5",
  "item.minecraft.dolphin_spawn_egg": "Яйце виклику дельфіна",
  "item.minecraft.donkey_spawn_egg": "Яйце виклику віслюка",
  "item.minecraft.dragon_breath": "Дихання дракона",
  "item.minecraft.dried_kelp": "Висушена ламінарія",
  "item.minecraft.drowned_spawn_egg": "Яйце виклику потопельника",
  "item.minecraft.dune_armor_trim_smithing_template": "Ковальський шаблон",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Орнамент обладунків «Дюна»",
  "item.minecraft.echo_shard": "Уламок відлуння",
  "item.minecraft.egg": "Яйце",
  "item.minecraft.elder_guardian_spawn_egg": "Яйце виклику стародавнього вартового",
  "item.minecraft.elytra": "Елітри",
  "item.minecraft.emerald": "Смарагд",
  "item.minecraft.enchanted_book": "Зачарована книга",
  "item.minecraft.enchanted_golden_apple": "Зачароване золоте яблуко",
  "item.minecraft.end_crystal": "Кристал Енду",
  "item.minecraft.ender_dragon_spawn_egg": "Яйце виклику дракона Енду",
  "item.minecraft.ender_eye": "Око Енду",
  "item.minecraft.ender_pearl": "Перлина Енду",
  "item.minecraft.enderman_spawn_egg": "Яйце виклику ендермена",
  "item.minecraft.endermite_spawn_egg": "Яйце виклику ендермайта",
  "item.minecraft.evoker_spawn_egg": "Яйце виклику заклинача",
  "item.minecraft.experience_bottle": "Пляшка чарів",
  "item.minecraft.explorer_pottery_shard": "Уламок горщика «Дослідник»",
  "item.minecraft.explorer_pottery_sherd": "Гончарний черепок «Дослідник»",
  "item.minecraft.eye_armor_trim_smithing_template": "Ковальський шаблон",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Орнамент обладунків «Око»",
  "item.minecraft.feather": "Перо",
  "item.minecraft.fermented_spider_eye": "Оброблене павуче око",
  "item.minecraft.field_masoned_banner_pattern": "Візерунок стяга «Цегляне тло»",
  "item.minecraft.filled_map": "Мапа",
  "item.minecraft.fire_charge": "Заряд вогню",
  "item.minecraft.firework_rocket": "Феєрверкова ракета",
  "item.minecraft.firework_rocket.flight": "Тривалість польоту:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Феєрверкова зірка",
  "item.minecraft.firework_star.black": "Чорна",
  "item.minecraft.firework_star.blue": "Синя",
  "item.minecraft.firework_star.brown": "Коричнева",
  "item.minecraft.firework_star.custom_color": "Власна",
  "item.minecraft.firework_star.cyan": "Бірюзова",
  "item.minecraft.firework_star.fade_to": "Затухання у",
  "item.minecraft.firework_star.flicker": "Мерехтіння",
  "item.minecraft.firework_star.gray": "Сіра",
  "item.minecraft.firework_star.green": "Зелена",
  "item.minecraft.firework_star.light_blue": "Блакитна",
  "item.minecraft.firework_star.light_gray": "Світло-сіра",
  "item.minecraft.firework_star.lime": "Лаймова",
  "item.minecraft.firework_star.magenta": "Пурпурова",
  "item.minecraft.firework_star.orange": "Помаранчева",
  "item.minecraft.firework_star.pink": "Рожева",
  "item.minecraft.firework_star.purple": "Фіолетова",
  "item.minecraft.firework_star.red": "Червона",
  "item.minecraft.firework_star.shape": "Невідома форма",
  "item.minecraft.firework_star.shape.burst": "Спалах",
  "item.minecraft.firework_star.shape.creeper": "Кріпероподібний",
  "item.minecraft.firework_star.shape.large_ball": "Велика куля",
  "item.minecraft.firework_star.shape.small_ball": "Мала куля",
  "item.minecraft.firework_star.shape.star": "Зіркоподібний",
  "item.minecraft.firework_star.trail": "Сліди",
  "item.minecraft.firework_star.white": "Біла",
  "item.minecraft.firework_star.yellow": "Жовта",
  "item.minecraft.fishing_rod": "Вудка",
  "item.minecraft.flint": "Кремінь",
  "item.minecraft.flint_and_steel": "Кресало",
  "item.minecraft.flow_armor_trim_smithing_template": "Ковальський шаблон",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Орнамент обладунків «Плин»",
  "item.minecraft.flow_banner_pattern": "Візерунок стяга",
  "item.minecraft.flow_banner_pattern.desc": "Плин",
  "item.minecraft.flow_banner_pattern.new": "Візерунок стяга «Плин»",
  "item.minecraft.flow_pottery_sherd": "Гончарний черепок «Плин»",
  "item.minecraft.flower_banner_pattern": "Візерунок стяга",
  "item.minecraft.flower_banner_pattern.desc": "Емблема квітки",
  "item.minecraft.flower_banner_pattern.new": "Візерунок стяга «Емблема квітки»",
  "item.minecraft.flower_pot": "Квітковий горщик",
  "item.minecraft.fox_spawn_egg": "Яйце виклику лисиці",
  "item.minecraft.friend_pottery_shard": "Уламок горщика «Друг»",
  "item.minecraft.friend_pottery_sherd": "Гончарний черепок «Друг»",
  "item.minecraft.frog_spawn_egg": "Яйце виклику жаби",
  "item.minecraft.furnace_minecart": "Вагонетка з піччю",
  "item.minecraft.ghast_spawn_egg": "Яйце виклику ґаста",
  "item.minecraft.ghast_tear": "Сльоза ґаста",
  "item.minecraft.glass_bottle": "Скляна пляшка",
  "item.minecraft.glistering_melon_slice": "Блискуча скибка кавуна",
  "item.minecraft.globe_banner_pattern": "Візерунок стяга",
  "item.minecraft.globe_banner_pattern.desc": "Глобус",
  "item.minecraft.globe_banner_pattern.new": "Візерунок стяга «Глобус»",
  "item.minecraft.glow_berries": "Сяйні ягоди",
  "item.minecraft.glow_ink_sac": "Сяйний чорнильний мішок",
  "item.minecraft.glow_item_frame": "Сяйна рамка для предметів",
  "item.minecraft.glow_squid_spawn_egg": "Яйце виклику сяйного кальмара",
  "item.minecraft.glowstone_dust": "Світлокам'яний пил",
  "item.minecraft.goat_horn": "Козячий ріг",
  "item.minecraft.goat_spawn_egg": "Яйце виклику кози",
  "item.minecraft.gold_ingot": "Золотий злиток",
  "item.minecraft.gold_nugget": "Золотий самородок",
  "item.minecraft.golden_apple": "Золоте яблуко",
  "item.minecraft.golden_axe": "Золота сокира",
  "item.minecraft.golden_boots": "Золоті чоботи",
  "item.minecraft.golden_carrot": "Золота морква",
  "item.minecraft.golden_chestplate": "Золотий нагрудник",
  "item.minecraft.golden_helmet": "Золотий шолом",
  "item.minecraft.golden_hoe": "Золота мотика",
  "item.minecraft.golden_horse_armor": "Золоті кінські обладунки",
  "item.minecraft.golden_leggings": "Золоті наголінники",
  "item.minecraft.golden_nautilus_armor": "Золоті обладунки навтилуса",
  "item.minecraft.golden_pickaxe": "Золоте кайло",
  "item.minecraft.golden_shovel": "Золота лопата",
  "item.minecraft.golden_spear": "Золотий спис",
  "item.minecraft.golden_sword": "Золотий меч",
  "item.minecraft.gray_bundle": "Сірий мішечок",
  "item.minecraft.gray_dye": "Сірий барвник",
  "item.minecraft.gray_harness": "Сіра упряж",
  "item.minecraft.green_bundle": "Зелений мішечок",
  "item.minecraft.green_dye": "Зелений барвник",
  "item.minecraft.green_harness": "Зелена упряж",
  "item.minecraft.guardian_spawn_egg": "Яйце виклику вартового",
  "item.minecraft.gunpowder": "Порох",
  "item.minecraft.guster_banner_pattern": "Візерунок стяга",
  "item.minecraft.guster_banner_pattern.desc": "Порив",
  "item.minecraft.guster_banner_pattern.new": "Візерунок стяга «Порив»",
  "item.minecraft.guster_pottery_sherd": "Гончарний черепок «Порив»",
  "item.minecraft.happy_ghast_spawn_egg": "Яйце виклику щасливого ґаста",
  "item.minecraft.harness": "Упряж",
  "item.minecraft.heart_of_the_sea": "Серце моря",
  "item.minecraft.heart_pottery_shard": "Уламок горщика «Серце»",
  "item.minecraft.heart_pottery_sherd": "Гончарний черепок «Серце»",
  "item.minecraft.heartbreak_pottery_shard": "Уламок горщика «Розбите серце»",
  "item.minecraft.heartbreak_pottery_sherd": "Гончарний черепок «Розбите серце»",
  "item.minecraft.hoglin_spawn_egg": "Яйце виклику гоґліна",
  "item.minecraft.honey_bottle": "Пляшка меду",
  "item.minecraft.honeycomb": "Медові стільники",
  "item.minecraft.hopper_minecart": "Вагонетка з лійкою",
  "item.minecraft.horse_spawn_egg": "Яйце виклику коня",
  "item.minecraft.host_armor_trim_smithing_template": "Ковальський шаблон",
  "item.minecraft.host_armor_trim_smithing_template.new": "Орнамент обладунків «Господар»",
  "item.minecraft.howl_pottery_shard": "Уламок горщика «Виття»",
  "item.minecraft.howl_pottery_sherd": "Гончарний черепок «Виття»",
  "item.minecraft.husk_spawn_egg": "Яйце виклику висушня",
  "item.minecraft.ink_sac": "Чорнильний мішок",
  "item.minecraft.iron_axe": "Залізна сокира",
  "item.minecraft.iron_boots": "Залізні чоботи",
  "item.minecraft.iron_chestplate": "Залізний нагрудник",
  "item.minecraft.iron_golem_spawn_egg": "Яйце виклику залізного ґолема",
  "item.minecraft.iron_helmet": "Залізний шолом",
  "item.minecraft.iron_hoe": "Залізна мотика",
  "item.minecraft.iron_horse_armor": "Залізні кінські обладунки",
  "item.minecraft.iron_ingot": "Залізний злиток",
  "item.minecraft.iron_leggings": "Залізні наголінники",
  "item.minecraft.iron_nautilus_armor": "Залізні обладунки навтилуса",
  "item.minecraft.iron_nugget": "Залізний самородок",
  "item.minecraft.iron_pickaxe": "Залізне кайло",
  "item.minecraft.iron_shovel": "Залізна лопата",
  "item.minecraft.iron_spear": "Залізний спис",
  "item.minecraft.iron_sword": "Залізний меч",
  "item.minecraft.item_frame": "Рамка для предметів",
  "item.minecraft.jungle_boat": "Тропічний човен",
  "item.minecraft.jungle_chest_boat": "Тропічний човен зі скринею",
  "item.minecraft.knowledge_book": "Книга знань",
  "item.minecraft.lapis_lazuli": "Лазурит",
  "item.minecraft.lava_bucket": "Відро лави",
  "item.minecraft.lead": "Повідець",
  "item.minecraft.leather": "Шкіра",
  "item.minecraft.leather_boots": "Шкіряні чоботи",
  "item.minecraft.leather_chestplate": "Шкіряна туніка",
  "item.minecraft.leather_helmet": "Шкіряна шапка",
  "item.minecraft.leather_horse_armor": "Шкіряні кінські обладунки",
  "item.minecraft.leather_leggings": "Шкіряні штани",
  "item.minecraft.light_blue_bundle": "Блакитний мішечок",
  "item.minecraft.light_blue_dye": "Блакитний барвник",
  "item.minecraft.light_blue_harness": "Блакитна упряж",
  "item.minecraft.light_gray_bundle": "Світло-сірий мішечок",
  "item.minecraft.light_gray_dye": "Світло-сірий барвник",
  "item.minecraft.light_gray_harness": "Світло-сіра упряж",
  "item.minecraft.lime_bundle": "Лаймовий мішечок",
  "item.minecraft.lime_dye": "Лаймовий барвник",
  "item.minecraft.lime_harness": "Лаймова упряж",
  "item.minecraft.lingering_potion": "Осідальне зілля",
  "item.minecraft.lingering_potion.effect.awkward": "Осідальне незграбне зілля",
  "item.minecraft.lingering_potion.effect.empty": "Осідальне нестворюване зілля",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Осідальне зілля вогнестійкости",
  "item.minecraft.lingering_potion.effect.harming": "Осідальне зілля шкоди",
  "item.minecraft.lingering_potion.effect.healing": "Осідальне зілля зцілення",
  "item.minecraft.lingering_potion.effect.infested": "Осідальне зілля зараження",
  "item.minecraft.lingering_potion.effect.invisibility": "Осідальне зілля невидимости",
  "item.minecraft.lingering_potion.effect.leaping": "Осідальне зілля стрибучости",
  "item.minecraft.lingering_potion.effect.levitation": "Осідальне зілля невагомости",
  "item.minecraft.lingering_potion.effect.luck": "Осідальне зілля везіння",
  "item.minecraft.lingering_potion.effect.mundane": "Звичайне осідальне зілля",
  "item.minecraft.lingering_potion.effect.night_vision": "Осідальне зілля нічного бачення",
  "item.minecraft.lingering_potion.effect.oozing": "Осідальне зілля слизькости",
  "item.minecraft.lingering_potion.effect.poison": "Осідальне зілля отруєння",
  "item.minecraft.lingering_potion.effect.regeneration": "Осідальне зілля регенерації",
  "item.minecraft.lingering_potion.effect.slow_falling": "Осідальне зілля повільного падіння",
  "item.minecraft.lingering_potion.effect.slowness": "Осідальне зілля повільности",
  "item.minecraft.lingering_potion.effect.strength": "Осідальне зілля сили",
  "item.minecraft.lingering_potion.effect.swiftness": "Осідальне зілля швидкости",
  "item.minecraft.lingering_potion.effect.thick": "Осідальне густе зілля",
  "item.minecraft.lingering_potion.effect.turtle_master": "Осідальне зілля майстра черепах",
  "item.minecraft.lingering_potion.effect.water": "Осідальна пляшка води",
  "item.minecraft.lingering_potion.effect.water_breathing": "Осідальне зілля водяного дихання",
  "item.minecraft.lingering_potion.effect.weakness": "Осідальне зілля слабкости",
  "item.minecraft.lingering_potion.effect.weaving": "Осідальне зілля плетіння",
  "item.minecraft.lingering_potion.effect.wind_charged": "Осідальне зілля вітряности",
  "item.minecraft.llama_spawn_egg": "Яйце виклику лами",
  "item.minecraft.lodestone_compass": "Намагнічений компас",
  "item.minecraft.mace": "Булава",
  "item.minecraft.magenta_bundle": "Пурпуровий мішечок",
  "item.minecraft.magenta_dye": "Пурпуровий барвник",
  "item.minecraft.magenta_harness": "Пурпурова упряж",
  "item.minecraft.magma_cream": "Магматичний крем",
  "item.minecraft.magma_cube_spawn_egg": "Яйце виклику магмокуба",
  "item.minecraft.mangrove_boat": "Мангровий човен",
  "item.minecraft.mangrove_chest_boat": "Мангровий човен зі скринею",
  "item.minecraft.map": "Порожня мапа",
  "item.minecraft.melon_seeds": "Насіння кавуна",
  "item.minecraft.melon_slice": "Скибка кавуна",
  "item.minecraft.milk_bucket": "Відро молока",
  "item.minecraft.minecart": "Вагонетка",
  "item.minecraft.miner_pottery_shard": "Уламок горщика «Шахтар»",
  "item.minecraft.miner_pottery_sherd": "Гончарний черепок «Шахтар»",
  "item.minecraft.mojang_banner_pattern": "Візерунок стяга",
  "item.minecraft.mojang_banner_pattern.desc": "Річ",
  "item.minecraft.mojang_banner_pattern.new": "Візерунок стяга «Річ»",
  "item.minecraft.mooshroom_spawn_egg": "Яйце виклику мушрума",
  "item.minecraft.mourner_pottery_shard": "Уламок горщика «Жалобник»",
  "item.minecraft.mourner_pottery_sherd": "Гончарний черепок «Жалобник»",
  "item.minecraft.mule_spawn_egg": "Яйце виклику мула",
  "item.minecraft.mushroom_stew": "Тушковані гриби",
  "item.minecraft.music_disc_11": "Платівка",
  "item.minecraft.music_disc_11.desc": "C418 — 11",
  "item.minecraft.music_disc_13": "Платівка",
  "item.minecraft.music_disc_13.desc": "C418 — 13",
  "item.minecraft.music_disc_5": "Платівка",
  "item.minecraft.music_disc_5.desc": "Самюель Оберг — 5",
  "item.minecraft.music_disc_blocks": "Платівка",
  "item.minecraft.music_disc_blocks.desc": "C418 — blocks",
  "item.minecraft.music_disc_cat": "Платівка",
  "item.minecraft.music_disc_cat.desc": "C418 — cat",
  "item.minecraft.music_disc_chirp": "Платівка",
  "item.minecraft.music_disc_chirp.desc": "C418 — chirp",
  "item.minecraft.music_disc_creator": "Платівка",
  "item.minecraft.music_disc_creator.desc": "Лейна Рейн — Creator",
  "item.minecraft.music_disc_creator_music_box": "Платівка",
  "item.minecraft.music_disc_creator_music_box.desc": "Лейна Рейн — Creator (музична скринька)",
  "item.minecraft.music_disc_far": "Платівка",
  "item.minecraft.music_disc_far.desc": "C418 — far",
  "item.minecraft.music_disc_lava_chicken": "Платівка",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions — Lava Chicken",
  "item.minecraft.music_disc_mall": "Платівка",
  "item.minecraft.music_disc_mall.desc": "C418 — mall",
  "item.minecraft.music_disc_mellohi": "Платівка",
  "item.minecraft.music_disc_mellohi.desc": "C418 — mellohi",
  "item.minecraft.music_disc_otherside": "Платівка",
  "item.minecraft.music_disc_otherside.desc": "Лейна Рейн — otherside",
  "item.minecraft.music_disc_pigstep": "Платівка",
  "item.minecraft.music_disc_pigstep.desc": "Лейна Рейн — Pigstep",
  "item.minecraft.music_disc_precipice": "Платівка",
  "item.minecraft.music_disc_precipice.desc": "Аарон Шероф — Precipice",
  "item.minecraft.music_disc_relic": "Платівка",
  "item.minecraft.music_disc_relic.desc": "Аарон Шероф — Relic",
  "item.minecraft.music_disc_stal": "Платівка",
  "item.minecraft.music_disc_stal.desc": "C418 — stal",
  "item.minecraft.music_disc_strad": "Платівка",
  "item.minecraft.music_disc_strad.desc": "C418 — strad",
  "item.minecraft.music_disc_tears": "Платівка",
  "item.minecraft.music_disc_tears.desc": "Еймос Родді — Tears",
  "item.minecraft.music_disc_wait": "Платівка",
  "item.minecraft.music_disc_wait.desc": "C418 — wait",
  "item.minecraft.music_disc_ward": "Платівка",
  "item.minecraft.music_disc_ward.desc": "C418 — ward",
  "item.minecraft.mutton": "Сира баранина",
  "item.minecraft.name_tag": "Ярлик",
  "item.minecraft.nautilus_shell": "Мушля навтилуса",
  "item.minecraft.nautilus_spawn_egg": "Яйце виклику навтилуса",
  "item.minecraft.nether_brick": "Незерська цеглина",
  "item.minecraft.nether_star": "Зірка Незеру",
  "item.minecraft.nether_wart": "Незерський наріст",
  "item.minecraft.netherite_axe": "Незеритова сокира",
  "item.minecraft.netherite_boots": "Незеритові чоботи",
  "item.minecraft.netherite_chestplate": "Незеритовий нагрудник",
  "item.minecraft.netherite_helmet": "Незеритовий шолом",
  "item.minecraft.netherite_hoe": "Незеритова мотика",
  "item.minecraft.netherite_horse_armor": "Незеритові кінські обладунки",
  "item.minecraft.netherite_ingot": "Незеритовий злиток",
  "item.minecraft.netherite_leggings": "Незеритові наголінники",
  "item.minecraft.netherite_nautilus_armor": "Незеритові обладунки навтилуса",
  "item.minecraft.netherite_pickaxe": "Незеритове кайло",
  "item.minecraft.netherite_scrap": "Незеритовий уламок",
  "item.minecraft.netherite_shovel": "Незеритова лопата",
  "item.minecraft.netherite_spear": "Незеритовий спис",
  "item.minecraft.netherite_sword": "Незеритовий меч",
  "item.minecraft.netherite_upgrade_smithing_template": "Ковальський шаблон",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Незеритове покращення",
  "item.minecraft.oak_boat": "Дубовий човен",
  "item.minecraft.oak_chest_boat": "Дубовий човен зі скринею",
  "item.minecraft.ocelot_spawn_egg": "Яйце виклику оцелота",
  "item.minecraft.ominous_bottle": "Зловісна пляшка",
  "item.minecraft.ominous_trial_key": "Зловісний ключ випробувань",
  "item.minecraft.orange_bundle": "Помаранчевий мішечок",
  "item.minecraft.orange_dye": "Помаранчевий барвник",
  "item.minecraft.orange_harness": "Помаранчева упряж",
  "item.minecraft.painting": "Картина",
  "item.minecraft.pale_oak_boat": "Блідо-дубовий човен",
  "item.minecraft.pale_oak_chest_boat": "Блідо-дубовий човен зі скринею",
  "item.minecraft.panda_spawn_egg": "Яйце виклику панди",
  "item.minecraft.paper": "Папір",
  "item.minecraft.parched_spawn_egg": "Яйце виклику засушня",
  "item.minecraft.parrot_spawn_egg": "Яйце виклику папуги",
  "item.minecraft.phantom_membrane": "Перетинка фантома",
  "item.minecraft.phantom_spawn_egg": "Яйце виклику фантома",
  "item.minecraft.pig_spawn_egg": "Яйце виклику свині",
  "item.minecraft.piglin_banner_pattern": "Візерунок стяга",
  "item.minecraft.piglin_banner_pattern.desc": "Рило",
  "item.minecraft.piglin_banner_pattern.new": "Візерунок стяга «Рило»",
  "item.minecraft.piglin_brute_spawn_egg": "Яйце виклику брутального піґліна",
  "item.minecraft.piglin_spawn_egg": "Яйце виклику піґліна",
  "item.minecraft.pillager_spawn_egg": "Яйце виклику розбійника",
  "item.minecraft.pink_bundle": "Рожевий мішечок",
  "item.minecraft.pink_dye": "Рожевий барвник",
  "item.minecraft.pink_harness": "Рожева упряж",
  "item.minecraft.pitcher_plant": "Глечник",
  "item.minecraft.pitcher_pod": "Стручок глечника",
  "item.minecraft.plenty_pottery_shard": "Уламок горщика «Достаток»",
  "item.minecraft.plenty_pottery_sherd": "Гончарний черепок «Достаток»",
  "item.minecraft.poisonous_potato": "Отруйна картопля",
  "item.minecraft.polar_bear_spawn_egg": "Яйце виклику білого ведмедя",
  "item.minecraft.popped_chorus_fruit": "Спечений фрукт хорусу",
  "item.minecraft.porkchop": "Сира свинина",
  "item.minecraft.potato": "Картопля",
  "item.minecraft.potion": "Зілля",
  "item.minecraft.potion.effect.awkward": "Незграбне зілля",
  "item.minecraft.potion.effect.empty": "Нестворюване зілля",
  "item.minecraft.potion.effect.fire_resistance": "Зілля вогнестійкости",
  "item.minecraft.potion.effect.harming": "Зілля шкоди",
  "item.minecraft.potion.effect.healing": "Зілля зцілення",
  "item.minecraft.potion.effect.infested": "Зілля зараження",
  "item.minecraft.potion.effect.invisibility": "Зілля невидимости",
  "item.minecraft.potion.effect.leaping": "Зілля стрибучости",
  "item.minecraft.potion.effect.levitation": "Зілля невагомости",
  "item.minecraft.potion.effect.luck": "Зілля везіння",
  "item.minecraft.potion.effect.mundane": "Звичайне зілля",
  "item.minecraft.potion.effect.night_vision": "Зілля нічного бачення",
  "item.minecraft.potion.effect.oozing": "Зілля слизькости",
  "item.minecraft.potion.effect.poison": "Зілля отруєння",
  "item.minecraft.potion.effect.regeneration": "Зілля регенерації",
  "item.minecraft.potion.effect.slow_falling": "Зілля повільного падіння",
  "item.minecraft.potion.effect.slowness": "Зілля повільности",
  "item.minecraft.potion.effect.strength": "Зілля сили",
  "item.minecraft.potion.effect.swiftness": "Зілля швидкости",
  "item.minecraft.potion.effect.thick": "Густе зілля",
  "item.minecraft.potion.effect.turtle_master": "Зілля майстра черепах",
  "item.minecraft.potion.effect.water": "Пляшка води",
  "item.minecraft.potion.effect.water_breathing": "Зілля водяного дихання",
  "item.minecraft.potion.effect.weakness": "Зілля слабкости",
  "item.minecraft.potion.effect.weaving": "Зілля плетіння",
  "item.minecraft.potion.effect.wind_charged": "Зілля вітряности",
  "item.minecraft.pottery_shard_archer": "Уламок горщика «Лучник»",
  "item.minecraft.pottery_shard_arms_up": "Уламок горщика «Руки догори»",
  "item.minecraft.pottery_shard_prize": "Уламок горщика «Нагорода»",
  "item.minecraft.pottery_shard_skull": "Уламок горщика «Череп»",
  "item.minecraft.powder_snow_bucket": "Відро із сипким снігом",
  "item.minecraft.prismarine_crystals": "Призмаринові кристали",
  "item.minecraft.prismarine_shard": "Призмариновий уламок",
  "item.minecraft.prize_pottery_shard": "Уламок горщика «Нагорода»",
  "item.minecraft.prize_pottery_sherd": "Гончарний черепок «Нагорода»",
  "item.minecraft.pufferfish": "Скелезуб",
  "item.minecraft.pufferfish_bucket": "Відро зі скелезубом",
  "item.minecraft.pufferfish_spawn_egg": "Яйце виклику скелезуба",
  "item.minecraft.pumpkin_pie": "Гарбузовий пиріг",
  "item.minecraft.pumpkin_seeds": "Насіння гарбуза",
  "item.minecraft.purple_bundle": "Фіолетовий мішечок",
  "item.minecraft.purple_dye": "Фіолетовий барвник",
  "item.minecraft.purple_harness": "Фіолетова упряж",
  "item.minecraft.quartz": "Незерський кварц",
  "item.minecraft.rabbit": "Сира кролятина",
  "item.minecraft.rabbit_foot": "Кроляча лапка",
  "item.minecraft.rabbit_hide": "Кроляча шкурка",
  "item.minecraft.rabbit_spawn_egg": "Яйце виклику кролика",
  "item.minecraft.rabbit_stew": "Тушкований кролик",
  "item.minecraft.raiser_armor_trim_smithing_template": "Ковальський шаблон",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Орнамент обладунків «Вирощувач»",
  "item.minecraft.ravager_spawn_egg": "Яйце виклику спустошувача",
  "item.minecraft.raw_copper": "Необроблена мідь",
  "item.minecraft.raw_gold": "Необроблене золото",
  "item.minecraft.raw_iron": "Необроблене залізо",
  "item.minecraft.recovery_compass": "Компас відновлення",
  "item.minecraft.red_bundle": "Червоний мішечок",
  "item.minecraft.red_dye": "Червоний барвник",
  "item.minecraft.red_harness": "Червона упряж",
  "item.minecraft.redstone": "Редстоуновий пил",
  "item.minecraft.resin_brick": "Смоляна цеглина",
  "item.minecraft.resin_clump": "Згусток смоли",
  "item.minecraft.rib_armor_trim_smithing_template": "Ковальський шаблон",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Орнамент обладунків «Ребра»",
  "item.minecraft.rotten_flesh": "Гнила плоть",
  "item.minecraft.saddle": "Сідло",
  "item.minecraft.salmon": "Сирий лосось",
  "item.minecraft.salmon_bucket": "Відро з лососем",
  "item.minecraft.salmon_spawn_egg": "Яйце виклику лосося",
  "item.minecraft.scrape_pottery_sherd": "Гончарний черепок «Шкребіння»",
  "item.minecraft.scute": "Щиток",
  "item.minecraft.sentry_armor_trim_smithing_template": "Ковальський шаблон",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Орнамент обладунків «Варта»",
  "item.minecraft.shaper_armor_trim_smithing_template": "Ковальський шаблон",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Орнамент обладунків «Скульптор»",
  "item.minecraft.sheaf_pottery_shard": "Уламок горщика «Сніп»",
  "item.minecraft.sheaf_pottery_sherd": "Гончарний черепок «Сніп»",
  "item.minecraft.shears": "Ножиці",
  "item.minecraft.sheep_spawn_egg": "Яйце виклику вівці",
  "item.minecraft.shelter_pottery_shard": "Уламок горщика «Укриття»",
  "item.minecraft.shelter_pottery_sherd": "Гончарний черепок «Укриття»",
  "item.minecraft.shield": "Щит",
  "item.minecraft.shield.black": "Чорний щит",
  "item.minecraft.shield.blue": "Синій щит",
  "item.minecraft.shield.brown": "Коричневий щит",
  "item.minecraft.shield.cyan": "Бірюзовий щит",
  "item.minecraft.shield.gray": "Сірий щит",
  "item.minecraft.shield.green": "Зелений щит",
  "item.minecraft.shield.light_blue": "Блакитний щит",
  "item.minecraft.shield.light_gray": "Світло-сірий щит",
  "item.minecraft.shield.lime": "Лаймовий щит",
  "item.minecraft.shield.magenta": "Пурпуровий щит",
  "item.minecraft.shield.orange": "Помаранчевий щит",
  "item.minecraft.shield.pink": "Рожевий щит",
  "item.minecraft.shield.purple": "Фіолетовий щит",
  "item.minecraft.shield.red": "Червоний щит",
  "item.minecraft.shield.white": "Білий щит",
  "item.minecraft.shield.yellow": "Жовтий щит",
  "item.minecraft.shulker_shell": "Панцир шалкера",
  "item.minecraft.shulker_spawn_egg": "Яйце виклику шалкера",
  "item.minecraft.sign": "Табличка",
  "item.minecraft.silence_armor_trim_smithing_template": "Ковальський шаблон",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Орнамент обладунків «Тиша»",
  "item.minecraft.silverfish_spawn_egg": "Яйце виклику лусківниці",
  "item.minecraft.skeleton_horse_spawn_egg": "Яйце виклику коня-скелета",
  "item.minecraft.skeleton_spawn_egg": "Яйце виклику скелета",
  "item.minecraft.skull_banner_pattern": "Візерунок стяга",
  "item.minecraft.skull_banner_pattern.desc": "Емблема черепа",
  "item.minecraft.skull_banner_pattern.new": "Візерунок стяга «Емблема черепа»",
  "item.minecraft.skull_pottery_shard": "Уламок горщика «Череп»",
  "item.minecraft.skull_pottery_sherd": "Гончарний черепок «Череп»",
  "item.minecraft.slime_ball": "Слизова кулька",
  "item.minecraft.slime_spawn_egg": "Яйце виклику слимака",
  "item.minecraft.smithing_template": "Ковальський шаблон",
  "item.minecraft.smithing_template.applies_to": "Застосовується до:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Розмістіть злиток або кристал",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Обладунки",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Розмістіть частину обладунків",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Злитки та кристали",
  "item.minecraft.smithing_template.ingredients": "Складники:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Розмістіть незеритовий злиток",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Діамантове спорядження",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Розмістіть діамантові обладунки, зброю або інструмент",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Незеритовий злиток",
  "item.minecraft.smithing_template.upgrade": "Покращення: ",
  "item.minecraft.sniffer_spawn_egg": "Яйце виклику нюхача",
  "item.minecraft.snort_pottery_shard": "Уламок горщика «Нюхач»",
  "item.minecraft.snort_pottery_sherd": "Гончарний черепок «Нюхач»",
  "item.minecraft.snout_armor_trim_smithing_template": "Ковальський шаблон",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Орнамент обладунків «Рило»",
  "item.minecraft.snow_golem_spawn_egg": "Яйце виклику снігового ґолема",
  "item.minecraft.snowball": "Сніжка",
  "item.minecraft.spectral_arrow": "Спектральна стріла",
  "item.minecraft.spider_eye": "Павуче око",
  "item.minecraft.spider_spawn_egg": "Яйце виклику павука",
  "item.minecraft.spire_armor_trim_smithing_template": "Ковальський шаблон",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Орнамент обладунків «Вежа»",
  "item.minecraft.splash_potion": "Вибухове зілля",
  "item.minecraft.splash_potion.effect.awkward": "Незграбне вибухове зілля",
  "item.minecraft.splash_potion.effect.empty": "Вибухове нестворюване зілля",
  "item.minecraft.splash_potion.effect.fire_resistance": "Вибухове зілля вогнестійкости",
  "item.minecraft.splash_potion.effect.harming": "Вибухове зілля шкоди",
  "item.minecraft.splash_potion.effect.healing": "Вибухове зілля зцілення",
  "item.minecraft.splash_potion.effect.infested": "Вибухове зілля зараження",
  "item.minecraft.splash_potion.effect.invisibility": "Вибухове зілля невидимости",
  "item.minecraft.splash_potion.effect.leaping": "Вибухове зілля стрибучости",
  "item.minecraft.splash_potion.effect.levitation": "Вибухове зілля невагомости",
  "item.minecraft.splash_potion.effect.luck": "Вибухове зілля везіння",
  "item.minecraft.splash_potion.effect.mundane": "Звичайне вибухове зілля",
  "item.minecraft.splash_potion.effect.night_vision": "Вибухове зілля нічного бачення",
  "item.minecraft.splash_potion.effect.oozing": "Вибухове зілля слизькости",
  "item.minecraft.splash_potion.effect.poison": "Вибухове зілля отруєння",
  "item.minecraft.splash_potion.effect.regeneration": "Вибухове зілля регенерації",
  "item.minecraft.splash_potion.effect.slow_falling": "Вибухове зілля повільного падіння",
  "item.minecraft.splash_potion.effect.slowness": "Вибухове зілля повільности",
  "item.minecraft.splash_potion.effect.strength": "Вибухове зілля сили",
  "item.minecraft.splash_potion.effect.swiftness": "Вибухове зілля швидкости",
  "item.minecraft.splash_potion.effect.thick": "Густе вибухове зілля",
  "item.minecraft.splash_potion.effect.turtle_master": "Вибухове зілля майстра черепах",
  "item.minecraft.splash_potion.effect.water": "Вибухова пляшка води",
  "item.minecraft.splash_potion.effect.water_breathing": "Вибухове зілля водяного дихання",
  "item.minecraft.splash_potion.effect.weakness": "Вибухове зілля слабкости",
  "item.minecraft.splash_potion.effect.weaving": "Вибухове зілля плетіння",
  "item.minecraft.splash_potion.effect.wind_charged": "Вибухове зілля вітряности",
  "item.minecraft.spruce_boat": "Смерековий човен",
  "item.minecraft.spruce_chest_boat": "Смерековий човен зі скринею",
  "item.minecraft.spyglass": "Підзорна труба",
  "item.minecraft.squid_spawn_egg": "Яйце виклику кальмара",
  "item.minecraft.stick": "Палиця",
  "item.minecraft.stone_axe": "Кам'яна сокира",
  "item.minecraft.stone_hoe": "Кам'яна мотика",
  "item.minecraft.stone_pickaxe": "Кам'яне кайло",
  "item.minecraft.stone_shovel": "Кам'яна лопата",
  "item.minecraft.stone_spear": "Кам'яний спис",
  "item.minecraft.stone_sword": "Кам'яний меч",
  "item.minecraft.stray_spawn_egg": "Яйце виклику примари",
  "item.minecraft.strider_spawn_egg": "Яйце виклику блукача",
  "item.minecraft.string": "Нитка",
  "item.minecraft.sugar": "Цукор",
  "item.minecraft.suspicious_stew": "Підозріла юшка",
  "item.minecraft.sweet_berries": "Солодкі ягоди",
  "item.minecraft.tadpole_bucket": "Відро з пуголовком",
  "item.minecraft.tadpole_spawn_egg": "Яйце виклику пуголовка",
  "item.minecraft.tide_armor_trim_smithing_template": "Ковальський шаблон",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Орнамент обладунків «Хвилі»",
  "item.minecraft.tipped_arrow": "Оброблена стріла",
  "item.minecraft.tipped_arrow.effect.awkward": "Оброблена стріла",
  "item.minecraft.tipped_arrow.effect.empty": "Нестворювана оброблена стріла",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Стріла вогнестійкости",
  "item.minecraft.tipped_arrow.effect.harming": "Стріла шкоди",
  "item.minecraft.tipped_arrow.effect.healing": "Стріла зцілення",
  "item.minecraft.tipped_arrow.effect.infested": "Стріла зараження",
  "item.minecraft.tipped_arrow.effect.invisibility": "Стріла невидимости",
  "item.minecraft.tipped_arrow.effect.leaping": "Стріла стрибучости",
  "item.minecraft.tipped_arrow.effect.levitation": "Стріла невагомости",
  "item.minecraft.tipped_arrow.effect.luck": "Стріла везіння",
  "item.minecraft.tipped_arrow.effect.mundane": "Оброблена стріла",
  "item.minecraft.tipped_arrow.effect.night_vision": "Стріла нічного бачення",
  "item.minecraft.tipped_arrow.effect.oozing": "Стріла слизькости",
  "item.minecraft.tipped_arrow.effect.poison": "Стріла отруєння",
  "item.minecraft.tipped_arrow.effect.regeneration": "Стріла регенерації",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Стріла повільного падіння",
  "item.minecraft.tipped_arrow.effect.slowness": "Стріла повільности",
  "item.minecraft.tipped_arrow.effect.strength": "Стріла сили",
  "item.minecraft.tipped_arrow.effect.swiftness": "Стріла швидкости",
  "item.minecraft.tipped_arrow.effect.thick": "Оброблена стріла",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Стріла із зіллям майстра черепах",
  "item.minecraft.tipped_arrow.effect.water": "Вибухова стріла",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Стріла водяного дихання",
  "item.minecraft.tipped_arrow.effect.weakness": "Стріла слабкости",
  "item.minecraft.tipped_arrow.effect.weaving": "Стріла плетіння",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Стріла вітряности",
  "item.minecraft.tnt_minecart": "Вагонетка з динамітом",
  "item.minecraft.torchflower_seeds": "Насіння смолоскипника",
  "item.minecraft.totem_of_undying": "Тотем безсмертя",
  "item.minecraft.trader_llama_spawn_egg": "Яйце виклику лами крамаря",
  "item.minecraft.trial_key": "Ключ випробувань",
  "item.minecraft.trident": "Тризубець",
  "item.minecraft.tropical_fish": "Тропічна риба",
  "item.minecraft.tropical_fish_bucket": "Відро з тропічною рибою",
  "item.minecraft.tropical_fish_spawn_egg": "Яйце виклику тропічної риби",
  "item.minecraft.turtle_helmet": "Панцир черепахи",
  "item.minecraft.turtle_scute": "Щиток черепахи",
  "item.minecraft.turtle_spawn_egg": "Яйце виклику черепахи",
  "item.minecraft.vex_armor_trim_smithing_template": "Ковальський шаблон",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Орнамент обладунків «Бісик»",
  "item.minecraft.vex_spawn_egg": "Яйце виклику бісика",
  "item.minecraft.villager_spawn_egg": "Яйце виклику селянина",
  "item.minecraft.vindicator_spawn_egg": "Яйце виклику поборника",
  "item.minecraft.wandering_trader_spawn_egg": "Яйце виклику мандрівного крамаря",
  "item.minecraft.ward_armor_trim_smithing_template": "Ковальський шаблон",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Орнамент обладунків «Боронитель»",
  "item.minecraft.warden_spawn_egg": "Яйце виклику боронителя",
  "item.minecraft.warped_fungus_on_a_stick": "Химерний гриб на паличці",
  "item.minecraft.water_bucket": "Відро води",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Ковальський шаблон",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Орнамент обладунків «Шляхошукач»",
  "item.minecraft.wheat": "Пшениця",
  "item.minecraft.wheat_seeds": "Насіння пшениці",
  "item.minecraft.white_bundle": "Білий мішечок",
  "item.minecraft.white_dye": "Білий барвник",
  "item.minecraft.white_harness": "Біла упряж",
  "item.minecraft.wild_armor_trim_smithing_template": "Ковальський шаблон",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Орнамент обладунків «Дикість»",
  "item.minecraft.wind_charge": "Заряд вітру",
  "item.minecraft.witch_spawn_egg": "Яйце виклику відьми",
  "item.minecraft.wither_skeleton_spawn_egg": "Яйце виклику візера-скелета",
  "item.minecraft.wither_spawn_egg": "Яйце виклику візера",
  "item.minecraft.wolf_armor": "Вовчі обладунки",
  "item.minecraft.wolf_spawn_egg": "Яйце виклику вовка",
  "item.minecraft.wooden_axe": "Дерев'яна сокира",
  "item.minecraft.wooden_hoe": "Дерев'яна мотика",
  "item.minecraft.wooden_pickaxe": "Дерев'яне кайло",
  "item.minecraft.wooden_shovel": "Дерев'яна лопата",
  "item.minecraft.wooden_spear": "Дерев'яний спис",
  "item.minecraft.wooden_sword": "Дерев'яний меч",
  "item.minecraft.writable_book": "Книга й перо",
  "item.minecraft.written_book": "Написана книга",
  "item.minecraft.yellow_bundle": "Жовтий мішечок",
  "item.minecraft.yellow_dye": "Жовтий барвник",
  "item.minecraft.yellow_harness": "Жовта упряж",
  "item.minecraft.zoglin_spawn_egg": "Яйце виклику зоґліна",
  "item.minecraft.zombie_horse_spawn_egg": "Яйце виклику зомбоконя",
  "item.minecraft.zombie_nautilus_spawn_egg": "Яйце виклику зомбонавтилуса",
  "item.minecraft.zombie_spawn_egg": "Яйце виклику зомбі",
  "item.minecraft.zombie_villager_spawn_egg": "Яйце виклику зомбоселянина",
  "item.minecraft.zombified_piglin_spawn_egg": "Яйце виклику зомбованого піґліна"
}
export const uk_ua = items; 
